const ar = {
  common: {
    close: "إغلاق",
    loadMore: "تحميل المزيد",
    shownCount: "عرض {{count}} سجل",
    error: "خطأ",
    warning: "تحذير",
    success: "تم بنجاح",
    cancel: "إلغاء",
    delete: "حذف",
    save: "حفظ",
    edit: "تعديل",
    create: "إنشاء",
    ok: "موافق",
    loading: "جارٍ التحميل...",
    retry: "إعادة المحاولة",
    back: "رجوع",
    share: "مشاركة",
    download: "تنزيل",
    rename: "إعادة تسمية",
    remove: "إزالة",
    na: "غير متوفر",
    user: "مستخدم",
    signInRequired: "يجب تسجيل الدخول",
    guestRestricted: "يرجى تسجيل الدخول للوصول إلى هذه الميزة.",
    info: "معلومات",
    refresh: "تحديث"
  },
  auth: {
    login: {
      title: "Future Document",
      subtitle: "برنامج إدارة الملفات السحابية للمؤسسات",
      email: "البريد الإلكتروني",
      emailPlaceholder: "example@email.com",
      password: "كلمة المرور",
      passwordPlaceholder: "••••••••",
      forgotPassword: "نسيت كلمة المرور",
      signIn: "تسجيل الدخول",
      noAccount: "ليس لديك حساب؟ ",
      signUp: "إنشاء حساب",
      licenseLookup: "البحث عن الترخيص",
      loginFailed: "فشل تسجيل الدخول",
      emailRequired: "البريد الإلكتروني مطلوب",
      emailRequiredMsg: "يرجى إدخال بريدك الإلكتروني لإعادة تعيين كلمة المرور.",
      emailSent: "تم الإرسال",
      emailSentMsg: "تم إرسال رابط إعادة تعيين كلمة المرور. (تجريبي)",
      orContinueWith: "أو تابع باستخدام",
      guestLogin: "المتابعة كضيف",
      guestLoginSubtext: "تصفح الصفحة الرئيسية بدون تسجيل الدخول"
    },
    register: {
      title: "إنشاء حساب",
      subtitle: "مرحباً بك في Future Document",
      fullName: "الاسم الكامل",
      fullNamePlaceholder: "محمد أحمد",
      email: "البريد الإلكتروني",
      emailPlaceholder: "example@email.com",
      password: "كلمة المرور",
      passwordPlaceholder: "••••••••",
      confirmPassword: "تأكيد كلمة المرور",
      confirmPasswordPlaceholder: "••••••••",
      licenseCode: "رمز الترخيص",
      licenseCodePlaceholder: "XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
      acceptTerms: "أوافق على ",
      termsOfService: "شروط الخدمة",
      and: " و",
      privacyPolicy: "سياسة الخصوصية",
      signUp: "إنشاء حساب",
      hasAccount: "لديك حساب بالفعل؟ ",
      signIn: "تسجيل الدخول",
      veryWeak: "ضعيف جداً",
      weak: "ضعيف",
      medium: "متوسط",
      strong: "قوي",
      veryStrong: "قوي جداً",
      fullNameRequired: "الاسم الكامل مطلوب",
      fullNameMin: "يجب أن يكون الاسم الكامل حرفين على الأقل",
      emailRequired: "البريد الإلكتروني مطلوب",
      emailInvalid: "يرجى إدخال بريد إلكتروني صالح",
      passwordRequired: "كلمة المرور مطلوبة",
      passwordMin: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      confirmPasswordRequired: "يرجى تأكيد كلمة المرور",
      passwordsNoMatch: "كلمات المرور غير متطابقة",
      licenseRequired: "رمز الترخيص مطلوب",
      licenseInvalid: "صيغة رمز الترخيص غير صالحة (المتوقع 25 حرفاً)",
      licenseVerifyFailed: "تعذر التحقق من رمز الترخيص.",
      licenseAlreadyActivated: "تم تفعيل رمز الترخيص هذا بالفعل.",
      licenseRegionTitle: "تحذير",
      licenseNotForTurkey: "لا يمكن استخدام رموز الترخيص هذه في تركيا.",
      mustBeSignedIn: "يجب تسجيل الدخول لتفعيل الترخيص.",
      mustAcceptTerms: "يجب قبول الشروط والأحكام.",
      registerError: "حدث خطأ أثناء التحقق من الترخيص."
    },
    support: {
      title: "طلب الدعم",
      subtitle: "لم يتم العثور على رمز الترخيص الخاص بك.",
      searchedLicense: "الترخيص المبحوث عنه: ",
      fullName: "الاسم الكامل *",
      fullNamePlaceholder: "أدخل اسمك الكامل",
      email: "البريد الإلكتروني *",
      emailPlaceholder: "example@company.com",
      companyName: "اسم الشركة (اختياري)",
      companyNamePlaceholder: "أدخل اسم شركتك",
      message: "رسالتك *",
      messagePlaceholder: "صف المشكلة المتعلقة برمز الترخيص...",
      submit: "إرسال الطلب",
      backToLogin: "العودة لتسجيل الدخول",
      fillRequired: "يرجى ملء جميع الحقول المطلوبة.",
      sendError: "حدث خطأ أثناء إرسال طلب الدعم.",
      requestReceived: "تم استلام الطلب!",
      requestReceivedMsg: "تم إنشاء طلب الدعم بنجاح."
    },
    licenseLookup: {
      title: "البحث عن الترخيص",
      subtitle: "أدخل رمز الترخيص المكون من 25 حرفاً لعرض معلومات الترخيص",
      licenseCode: "رمز الترخيص",
      format: "الصيغة: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
      placeholder: "XXXXX",
      lookup: "البحث عن الترخيص",
      notFoundTitle: "لم يتم العثور على الترخيص",
      notFoundMsg: "لم يتم العثور على رمز الترخيص المدخل في نظامنا.",
      createSupport: "إنشاء طلب دعم",
      purchaseLicense: "شراء ترخيص جديد",
      enterComplete: "يرجى إدخال رمز الترخيص كاملاً",
      lookupError: "حدث خطأ أثناء البحث عن الترخيص."
    },
    licenseInfo: {
      title: "معلومات الترخيص",
      subtitle: "تفاصيل الترخيص الخاص بك",
      noData: "لا توجد بيانات ترخيص",
      noDataDesc: "يرجى البحث عن ترخيص أولاً.",
      licenseCode: "رمز الترخيص",
      type: "نوع الترخيص",
      maxUsers: "الحد الأقصى للمستخدمين",
      activatedBy: "تم التفعيل بواسطة",
      expiresAt: "تاريخ الانتهاء",
      activated: "مُفعّل",
      available: "متاح",
      activateNow: "تفعيل الآن"
    },
    errors: {
      emailInUse: "هذا البريد الإلكتروني مستخدم بالفعل.",
      invalidEmail: "عنوان بريد إلكتروني غير صالح.",
      operationNotAllowed: "هذه العملية غير متاحة حالياً.",
      weakPassword: "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
      userDisabled: "تم تعطيل هذا الحساب.",
      userNotFound: "لم يتم العثور على مستخدم بهذا البريد الإلكتروني.",
      wrongPassword: "كلمة المرور غير صحيحة.",
      invalidCredential: "بيانات تسجيل الدخول غير صالحة.",
      tooManyRequests: "محاولات فاشلة كثيرة. يرجى المحاولة لاحقاً.",
      networkError: "خطأ في الاتصال بالشبكة.",
      generic: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      notSignedIn: "لم يتم تسجيل الدخول"
    }
  },
  home: {
    goodMorning: "صباح الخير",
    goodAfternoon: "مساء الخير",
    goodEvening: "مساء الخير",
    defaultUser: "FutureDoc",
    folders: "المجلدات",
    files: "الملفات",
    gbUsage: "جيجابايت مستخدمة",
    quickActions: "إجراءات سريعة",
    upload: "رفع",
    foldersAction: "مجلدات",
    aiAssistant: "مساعد الذكاء الاصطناعي",
    notifications: "الإشعارات",
    recentFiles: "الملفات الأخيرة",
    seeAll: "عرض الكل",
    noFilesYet: "لم يتم رفع أي ملفات بعد",
    uploadFirstFile: "رفع أول ملف",
    cloudStorage: "التخزين السحابي",
    storageUsed: "{{used}} جيجابايت / {{total}} جيجابايت مستخدمة",
    minAgo: "منذ {{count}} دقيقة",
    hoursAgo: "منذ {{count}} ساعة",
    daysAgo: "منذ {{count}} يوم"
  },
  ai: {
    chat: {
      title: "مساعد المستندات",
      systemMessage: "مرحباً! أنا مساعد المستندات الخاص بك.",
      welcomeMsg: "مرحباً! يمكنني مساعدتك في البحث داخل مستنداتك والإجابة عن الأسئلة المتعلقة بمحتواها وتقديم رؤى. ماذا تود أن تعرف؟",
      tempResponse: "هذه الميزة في انتظار تكامل واجهة برمجة التطبيقات.",
      guardrails: "الإجابات تستند فقط إلى مستنداتك المرفوعة",
      typing: "جارٍ فحص المستندات...",
      placeholder: "اطرح سؤالاً حول مستنداتك...",
      sources: "المصادر:",
      page: "صفحة {{num}}",
      citationTitle: "المستند المصدر",
      citationInfo: "المصدر: {{fileName}}\nالصفحة: {{page}}",
      citationOpenError: "تعذر فتح المستند المصدر."
    },
    ocr: {
      title: "نتيجة التعرف الضوئي",
      fileNotFound: "الملف غير موجود",
      confidenceScore: "درجة الثقة",
      classification: "التصنيف",
      unidentified: "غير محدد",
      approvalRequired: "مطلوب الموافقة (HITL)",
      approvalMsg: "درجة ثقة التعرف الضوئي أقل من 80%.",
      tags: "العلامات",
      extractedText: "النص المستخرج",
      characters: "{{count}} حرف",
      noOcrText: "لم يتم العثور على نص.",
      piiTitle: "تم اكتشاف بيانات حساسة (PII/DLP)",
      piiMsg: "تم اكتشاف بيانات حساسة في هذا المستند.",
      approveBtn: "الموافقة على نتيجة التعرف الضوئي",
      highConfidence: "ثقة عالية",
      mediumConfidence: "ثقة متوسطة",
      lowConfidence: "ثقة منخفضة",
      veryLowConfidence: "ثقة منخفضة جداً",
      loadError: "فشل تحميل الملف.",
      approved: "تمت الموافقة",
      approvedMsg: "تمت الموافقة على نتيجة التعرف الضوئي.",
      approvalFailed: "فشلت عملية الموافقة."
    }
  },
  search: {
    title: "البحث",
    subtitle: "البحث في محتوى الملفات والأسماء والعلامات وتصنيفات الذكاء الاصطناعي",
    placeholder: "البحث في الملفات أو العلامات أو المحتوى...",
    pendingApproval: "بانتظار الموافقة",
    processing: "قيد المعالجة",
    scanning: "قيد الفحص",
    quarantined: "معزول",
    tipsTitle: "نصائح البحث",
    tipFileName: "البحث حسب اسم الملف",
    tipTags: "البحث حسب العلامات",
    tipOcr: "البحث في نص التعرف الضوئي",
    tipAi: "البحث حسب تصنيف الذكاء الاصطناعي",
    noResults: "لم يتم العثور على نتائج",
    tryDifferent: "جرب كلمات مفتاحية مختلفة أو عدّل الفلاتر",
    advancedFilters: "فلاتر متقدمة",
    recentSearches: "عمليات البحث الأخيرة",
    clearRecent: "مسح",
    popularTags: "العلامات الشائعة",
    noTagsAvailable: "لا توجد علامات متاحة",
    resultCount: "{{count}} نتيجة ({{total}} ملف إجمالي)",
    sortBy: "ترتيب",
    sortOptions: { relevance: "الصلة", date: "التاريخ", name: "الاسم", size: "الحجم" },
    page: "صفحة",
    matchTypes: { name: "الاسم", tag: "العلامة", content: "المحتوى", classification: "التصنيف" },
    columns: { name: "الاسم", match: "التطابق", score: "النقاط", size: "الحجم", status: "الحالة", tags: "العلامات", date: "التاريخ" },
    filters: {
      title: "تصفية النتائج",
      fileType: "نوع الملف",
      status: "الحالة",
      folder: "المجلد",
      allFolders: "جميع المجلدات",
      dateRange: "نطاق التاريخ",
      dateFrom: "من",
      dateTo: "إلى",
      sizeRange: "حجم الملف",
      sizeMin: "الحد الأدنى (بايت)",
      sizeMax: "الحد الأقصى (بايت)",
      sizeHint: "الحجم بالبايت (مثال: 1048576 = 1 ميغابايت)",
      tags: "العلامات",
      clearAll: "مسح الكل",
      apply: "تطبيق",
      types: { all: "جميع الأنواع", pdf: "PDF", doc: "مستندات", image: "صور", spreadsheet: "جداول بيانات", presentation: "عروض تقديمية", other: "أخرى" },
      statuses: { all: "جميع الحالات", READY: "جاهز", PROCESSING: "قيد المعالجة", NEED_APPROVAL: "يحتاج موافقة", QUARANTINED: "معزول" }
    }
  },
  files: {
    move: {
      action: "نقل",
      title: "نقل \"{{name}}\"",
      destination: "المجلد الوجهة",
      root: "المستوى الأعلى (بدون مجلد)",
      confirm: "نقل",
      done: "تم النقل.",
      failed: "فشل النقل.",
      errorSelf: "لا يمكن نقل مجلد إلى داخله.",
      errorChild: "لا يمكن نقل مجلد إلى أحد مجلداته الفرعية.",
      errorDepth: "سيتجاوز هذا حد عمق المجلدات (10 مستويات).",
      errorMissing: "العنصر أو المجلد الوجهة لم يعد موجودًا.",
      newSubfolderIn: "مجلد جديد في \"{{name}}\""
    },
    title: "ملفاتي",
    noFilesYet: "لا توجد ملفات بعد",
    detail: {
      title: "تفاصيل الملف",
      fileNotFound: "الملف غير موجود.",
      details: "التفاصيل",
      created: "تاريخ الإنشاء",
      modified: "تاريخ التعديل",
      size: "الحجم",
      type: "النوع",
      folder: "المجلد",
      file: "ملف",
      loadError: "فشل تحميل معلومات الملف.",
      preview: "معاينة",
      tapToPreview: "اضغط للمعاينة",
      noDownloadUrl: "رابط التحميل غير متاح.",
      demoDownload: "التحميل معطل في الوضع التجريبي.",
      demoDelete: "الحذف معطل في الوضع التجريبي.",
      saveFile: "حفظ الملف",
      downloadComplete: "تم تنزيل الملف إلى: {{path}}",
      downloadError: "فشل تنزيل الملف.",
      deleteTitle: "حذف الملف",
      deleteMsg: "سيتم نقل \"{{name}}\" إلى سلة المحذوفات. يمكنك استعادته خلال 30 يومًا.",
      deleteSuccess: "تم حذف الملف بنجاح.",
      deleteError: "فشل حذف الملف.",
      ocrAvailable: "نص OCR متاح",
      ocrDesc: "عرض النص المستخرج",
      versionHistory: "سجل الإصدارات",
      versions: "الإصدارات",
      noVersions: "لا توجد إصدارات محفوظة بعد.",
      viewAllVersions: "عرض الكل",
      versionHistoryDesc: "عرض واستعادة الإصدارات السابقة"
    },
    preview: {
      title: "معاينة الملف",
      loading: "جاري تحميل الملف...",
      loadError: "فشل تحميل الملف.",
      noUrl: "رابط الملف غير متاح.",
      unsupportedType: "نوع الملف هذا غير مدعوم للمعاينة.",
      unsupportedTitle: "المعاينة غير متاحة",
      fileNotFound: "الملف غير موجود."
    },
    status: { scanning: "جاري الفحص", processing: "جاري المعالجة", need_approval: "يحتاج موافقة", quarantined: "معزول", ready: "جاهز" },
    upload: {
      quotaWarning: "لقد استخدمت أكثر من 80٪ من حصتك: التخزين {{storage}}٪، العمليات {{ops}}٪.",
      quotaBlockedStorage: "حصة التخزين ممتلئة؛ لا يمكن رفع هذه الملفات. حرّر مساحة أو قم بترقية خطتك.",
      quotaBlockedOps: "تم استنفاد حصة العمليات الشهرية؛ الرفع محظور.",
      title: "رفع ملف",
      tapToSelect: "اضغط أو اسحب الملفات هنا",
      formats: "PDF, DOCX, XLSX, PPTX, JPG, PNG, TIFF",
      maxSize: "الحد الأقصى 5 جيجابايت",
      tags: "العلامات (افصل بفواصل)",
      tagsPlaceholder: "فاتورة، 2026، مهم",
      targetFolder: "المجلد الهدف",
      rootFolder: "الجذر (بدون مجلد)",
      selectedFiles: "الملفات المختارة ({{count}})",
      uploadBtn: "رفع {{count}} ملفات",
      sizeError: "خطأ في الحجم",
      sizeErrorMsg: "{{name}} يتجاوز حد 5 جيجابايت.",
      selectWarning: "يرجى اختيار ملف واحد على الأقل.",
      uploadComplete: "اكتمل الرفع",
      uploadSuccessMsg: "تم رفع {{success}} ملفات بنجاح!",
      uploadPartialMsg: "تم رفع {{success}} ملفات، فشل {{fail}} ملفات."
    },
    versions: {
      title: "سجل الإصدارات",
      loadError: "فشل تحميل سجل الإصدارات.",
      versionNum: "الإصدار {{num}}",
      current: "الحالي",
      today: "اليوم",
      yesterday: "أمس",
      daysAgo: "منذ {{count}} يوم",
      restore: "استعادة",
      restoreTitle: "استعادة الإصدار",
      restoreMsg: "هل أنت متأكد من استعادة الإصدار {{version}}؟",
      restoreSuccess: "تم استعادة الإصدار بنجاح.",
      restoreConfirm: "سيؤدي هذا إلى استبدال الإصدار الحالي. سيتم حفظ نسخة احتياطية من الإصدار الحالي تلقائياً.",
      restoreNote: "ملاحظة التغيير",
      demoRestore: "استعادة الإصدار معطلة في الوضع التجريبي.",
      demoDownload: "تنزيل الإصدار معطل في الوضع التجريبي.",
      noVersions: "لا يوجد سجل إصدارات",
      noVersionsDesc: "سيظهر سجل الإصدارات هنا عند إجراء تغييرات.",
      compareVersions: "مقارنة الإصدارات",
      selectSecond: "اختر إصداراً آخر للمقارنة.",
      readyToCompare: "تم اختيار إصدارين — انقر على مقارنة الإصدارات.",
      clearSelection: "مسح الاختيار",
      changeNote: "ملاحظة التغيير",
      changeNotePlaceholder: "صف ما تم تغييره في هذا الإصدار…",
      changeNoteRequired: "ملاحظة التغيير مطلوبة عند رفع إصدار جديد.",
      sizeChange: "تغيير الحجم",
      totalVersions: "إجمالي الإصدارات",
      latestSize: "حجم الأحدث",
      totalSize: "الحجم الإجمالي",
      fileSize: "حجم الملف",
      preview: "معاينة",
      download: "تنزيل",
      previewUnavailable: "المعاينة غير متاحة لهذا النوع من الملفات.",
      uploadNew: "رفع إصدار جديد",
      selectFile: "اختر ملف",
      upload: "رفع",
      uploadSuccess: "تم رفع الإصدار الجديد بنجاح.",
      uploadError: "فشل رفع الإصدار الجديد.",
      demoUpload: "رفع الإصدار معطل في الوضع التجريبي.",
      older: "الأقدم",
      newer: "الأحدث"
    },
    share: {
      byRole: "المشاركة حسب الدور",
      byRoleHint: "يمكن لكل من في شركتك ممن لديهم الأدوار المحددة الوصول إلى الملف. لا يمكن للأدوار نفسها في شركات أخرى ذلك.",
      saveRoles: "حفظ المشاركة حسب الدور",
      rolesSaved: "تمت مشاركة الملف مع {{count}} دور.",
      rolesCleared: "تمت إزالة المشاركة حسب الدور.",
      rolesFailed: "تعذر حفظ المشاركة حسب الدور.",
      rolesNoCompany: "تتطلب المشاركة حسب الدور أن يكون حسابك تابعًا لشركة.",
      sharedWithMyRole: "تمت مشاركتها مع دوري",
      title: "مشاركة الملف",
      newShare: "مشاركة جديدة",
      emailAddress: "البريد الإلكتروني",
      emailPlaceholder: "user@company.com",
      permissionLevel: "مستوى الصلاحية",
      timeLimit: "المهلة الزمنية (أيام، اختياري)",
      timeLimitPlaceholder: "بدون حد",
      shareBtn: "مشاركة",
      sharedWith: "تمت المشاركة مع ({{count}})",
      notSharedYet: "لم تتم المشاركة مع أحد بعد",
      view: "عرض",
      editPerm: "تعديل",
      downloadPerm: "تنزيل",
      loadError: "فشل تحميل البيانات.",
      emailEmpty: "يرجى إدخال بريد إلكتروني.",
      emailInvalid: "يرجى إدخال بريد إلكتروني صالح.",
      shareSuccess: "تمت مشاركة الملف مع {{email}}.",
      shareFailed: "فشلت المشاركة.",
      revokeTitle: "إلغاء المشاركة",
      revokeMsg: "سيتم إزالة صلاحية الوصول لـ {{email}}.",
      revokeFailed: "فشلت عملية الإلغاء."
    },
    trash: {
      title: "سلة المحذوفات",
      retention: "تُحذف العناصر المحذوفة نهائيًا بعد {{count}} يومًا.",
      empty: "سلة المحذوفات فارغة",
      name: "الاسم",
      deletedAt: "تاريخ الحذف",
      purgeIn: "الحذف النهائي خلال",
      days: "{{count}} يوم",
      folder: "مجلد",
      restore: "استعادة",
      deleteForever: "حذف نهائي",
      emptyTrash: "إفراغ سلة المحذوفات",
      emptyConfirm: "سيتم حذف جميع العناصر في سلة المحذوفات نهائيًا. لا يمكن التراجع عن ذلك.",
      deleteForeverConfirm: "سيتم حذف \"{{name}}\" نهائيًا. لا يمكن التراجع عن ذلك.",
      loadError: "تعذر تحميل سلة المحذوفات.",
      actionError: "تعذر إكمال العملية. يرجى المحاولة مرة أخرى."
    },
    folders: {
      title: "المجلدات",
      fileCount: "{{count}} ملفات",
      noFoldersYet: "لا توجد مجلدات بعد",
      noFoldersMsg: "أنشئ مجلداً جديداً لتنظيم ملفاتك.",
      newFolder: "مجلد جديد",
      folderName: "اسم المجلد",
      newName: "الاسم الجديد",
      deleteFolder: "حذف المجلد",
      deleteFolderMsg: "سيتم نقل المجلد \"{{name}}\" وملفاته إلى سلة المحذوفات، وتنتقل المجلدات الفرعية مستوى واحدًا للأعلى. يمكنك استعادته خلال 30 يومًا.",
      folderCreated: "تم إنشاء المجلد!",
      loadError: "فشل تحميل المجلدات.",
      createError: "فشل إنشاء المجلد.",
      renameError: "فشل إعادة تسمية المجلد.",
      deleteError: "فشل حذف المجلد.",
      nameEmpty: "لا يمكن أن يكون اسم المجلد فارغاً."
    }
  },
  settings: {
    title: "الإعدادات",
    account: "الحساب",
    application: "التطبيق",
    supportSection: "الدعم",
    profile: "الملف الشخصي",
    profileDesc: "إدارة معلومات حسابك",
    notifications: "الإشعارات",
    notificationsDesc: "تفضيلات الإشعارات",
    security: "الأمان",
    securityDesc: "إعدادات الأمان",
    workspace: "مساحة العمل",
    workspaceDesc: "التبديل بين مساحات العمل",
    storage: "التخزين",
    storageDesc: "معلومات الحصة والاستخدام",
    appearance: "المظهر",
    appearanceDesc: "تفضيلات السمة واللغة",
    language: "اللغة",
    languageDesc: "اختيار لغة التطبيق",
    adminPanel: "لوحة الإدارة",
    adminPanelDesc: "معلومات الشركة وفريقك والحصة وسجلات المراجعة",
    helpSupport: "المساعدة والدعم",
    helpSupportDesc: "الأسئلة الشائعة وطلبات الدعم",
    helpSupportMsg: "للدعم، يمكنك إرسال بريد إلكتروني إلى support@futuredocument.com.",
    privacyPolicy: "سياسة الخصوصية",
    privacyPolicyDesc: "سياسات خصوصية البيانات",
    termsOfService: "شروط الخدمة",
    termsOfServiceDesc: "شروط وأحكام الخدمة",
    kvkk: "نص توضيح KVKK",
    kvkkDesc: "نص توضيح حماية البيانات الشخصية",
    distanceSales: "عقد البيع عن بُعد",
    distanceSalesDesc: "عقد البيع عن بُعد للخدمات الرقمية",
    deliveryConditions: "شروط التسليم والخدمة",
    deliveryConditionsDesc: "التفعيل والدعم وتقديم الخدمة",
    cancellationReturn: "الإلغاء والاسترداد والعدول",
    cancellationReturnDesc: "شروط الإلغاء والاسترداد والعدول",
    about: "حول",
    aboutDesc: "معلومات إصدار التطبيق",
    aboutMsg: "الإصدار 1.0.0\n© 2026 Future Tech Works Software Company",
    signOut: "تسجيل الخروج",
    signOutConfirm: "هل أنت متأكد من تسجيل الخروج؟",
    comingSoon: "الوصول مقيّد في الوضع التجريبي.",
    version: "FutureDoc v1.0.0"
  },
  profile: {
    title: "الملف الشخصي",
    profileInfo: "المعلومات الشخصية",
    name: "الاسم",
    namePlaceholder: "اسمك",
    email: "البريد الإلكتروني",
    userId: "معرف المستخدم",
    emailVerified: "البريد الإلكتروني مُوثّق",
    emailNotVerified: "البريد الإلكتروني غير مُوثّق",
    changePassword: "تغيير كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    updatePassword: "تحديث كلمة المرور",
    deleteAccount: "حذف الحساب",
    deleteAccountMsg: "هذا الإجراء لا يمكن التراجع عنه.",
    deleteMyAccount: "حذف حسابي",
    nameEmpty: "لا يمكن أن يكون الاسم فارغاً.",
    profileUpdated: "تم تحديث ملفك الشخصي.",
    profileUpdateError: "فشل تحديث الملف الشخصي.",
    fillAllFields: "يرجى ملء جميع الحقول.",
    passwordMinLength: "يجب أن تكون كلمة المرور الجديدة 6 أحرف على الأقل.",
    passwordsNoMatch: "كلمات المرور غير متطابقة.",
    passwordUpdated: "تم تحديث كلمة المرور.",
    wrongPassword: "كلمة المرور الحالية غير صحيحة.",
    passwordChangeError: "فشل تغيير كلمة المرور.",
    accountDeleted: "تم حذف الحساب",
    accountDeletedMsg: "تم حذف حسابك وجميع البيانات بنجاح.",
    deleteError: "فشل حذف الحساب."
  },
  admin: {
    deactivateUser: "تعطيل",
    activateUser: "تفعيل",
    inactiveBadge: "معطّل",
    confirmDeactivate: "هل تريد تعطيل {{email}}؟ سيتم تسجيل خروج المستخدم فورًا ولن يتمكن من تسجيل الدخول مجددًا.",
    userDeactivated: "تم تعطيل {{email}}.",
    userActivated: "{{email}} نشط مجددًا.",
    userStatusFailed: "تعذّر تغيير حالة المستخدم.",
    title: "لوحة الإدارة",
    orgPanelTitle: "لوحة الإدارة",
    orgPanelSubtitle: "إدارة شركتك وحسابات فريقك",
    orgPanelSubtitleCompany: "إدارة {{name}}",
    platformPanelSubtitle: "إدارة المستخدمين والأدوار والتراخيص على مستوى المنصة",
    companyTab: "الشركة",
    teamTab: "فريقي",
    soldCompaniesTab: "الشركات المباعة",
    soldCompaniesHelp: "الشركات ذات دور Company التي اشترت ترخيصاً تحت حساب Admin الخاص بك. اعرض ارتباط الترخيص والموزعين/المستخدمين التابعين.",
    drpackLicensesTitle: "جميع التراخيص",
    drpackLicensesHelp: "نسخة للقراءة فقط من تراخيص Firebase. جدول licenses لا يُعدَّل أبداً.",
    syncDrpackLicenses: "مزامنة من licenses",
    drpackSynced: "تمت مزامنة {{count}} ترخيص إلى AdminLicenses.",
    drpackSyncError: "فشلت مزامنة التراخيص.",
    drpackLoadError: "فشل تحميل التراخيص.",
    drpackSyncedCount: "التراخيص المزامنة",
    drpackCountriesCount: "الدول",
    drpackCompaniesCount: "الشركات المستخدمة",
    drpackUsedCount: "التراخيص المستخدمة",
    drpackActivatedCount: "مفعّل",
    drpackAvailableCount: "متاح",
    searchDrpackLicenses: "البحث بالدولة أو الشركة أو الرمز…",
    noDrpackLicenses: "لا توجد تراخيص في AdminLicenses بعد.",
    noDrpackLicensesHint: "انقر «مزامنة من licenses» لنسخ السجلات إلى AdminLicenses.",
    groupByCountry: "حسب الدولة المعيّنة",
    groupByUsingCompany: "حسب الشركة المستخدمة",
    drpackUnknownCountry: "دولة غير معروفة",
    drpackUnassignedCompany: "شركة غير معيّنة",
    drpackLicenseUnit: "تراخيص",
    drpackAssignedCountry: "الدولة المعيّنة",
    drpackUsingCompany: "الشركة المستخدمة",
    drpackSoldTo: "البائع",
    drpackValidUntil: "صالح حتى",
    drpackUsed: "مستخدم",
    drpackUnused: "غير مستخدم",
    drpackType: "النوع",
    drpackStatus: "الحالة",
    drpackMaxUsers: "أقصى مستخدمين",
    drpackActivated: "مفعّل",
    drpackAvailable: "متاح",
    drpackLicenseDetail: "تفاصيل الترخيص",
    drpackActivatedBy: "تم التفعيل بواسطة",
    drpackSource: "المصدر",
    drpackRawFields: "حقول الترخيص",
    soldCompaniesTotal: "الشركات المباعة",
    soldCompaniesWithLicense: "مع رمز ترخيص",
    soldCompaniesNetwork: "حسابات الشبكة",
    searchSoldCompanies: "البحث في الشركات",
    searchSoldCompaniesPlaceholder: "الاسم، البريد، الترخيص، البلد…",
    noSoldCompanies: "لا توجد شركات مباعة بعد",
    noSoldCompaniesDesc: "أنشئ حساباً بدور Company لمشتري التراخيص في الخارج.",
    addCompanyAccount: "إضافة شركة",
    addCompanyHelp: "أنشئ حساب Company لمشترٍ في الخارج (مثل Erbil Plastic). اسم الشركة التجاري مطلوب؛ باقي الحقول اختيارية.",
    viewCompany: "عرض",
    editSoldCompany: "تعديل الشركة",
    soldCompanyDetail: "تفاصيل الشركة",
    soldCompanyInfoHelp: "عدّل اسم وملف هذه الشركة المباعة. الاسم التجاري مطلوب؛ باقي الحقول اختيارية.",
    soldCompanyInfoRequired: "الاسم التجاري مطلوب لحسابات الشركة.",
    soldCompanyUpdated: "تم تحديث معلومات الشركة.",
    licenseCode: "رمز الترخيص",
    licenseLinkedViaRole: "مرتبط عبر دور Company",
    networkSize: "الشبكة",
    companyNetwork: "الحسابات تحت هذه الشركة",
    companyNetworkEmpty: "لا يوجد موزعون أو مستخدمون أو مشاهدون تحت هذه الشركة بعد.",
    orgCompanyIntro: "حدّث ملف شركتك المرخّصة. هذا مطلوب لحسابات Admin.",
    orgUsersHelp: "يمكنك إدارة حسابات Company و Dealer و User و Viewer ضمن مؤسستك.",
    addTeamUser: "إضافة مستخدم للفريق",
    saveCompany: "حفظ معلومات الشركة",
    companySaved: "تم حفظ معلومات الشركة.",
    companySaveError: "فشل حفظ معلومات الشركة.",
    cannotEditPeerAdmin: "لا يمكنك تعديل حسابات Admin الأخرى.",
    myLicensesTab: "تراخيصي",
    myLicensesIntro: "التراخيص المخصصة لشركتك مع تفاصيل المنتج والبائع والصلاحية.",
    myLicensesTotal: "إجمالي التراخيص",
    myLicensesValid: "التراخيص الصالحة",
    myLicenseProduct: "المنتج",
    myLicenseValid: "صالح",
    myLicenseExpired: "منتهي الصلاحية",
    searchMyLicenses: "ابحث بالرمز أو المنتج أو البائع أو التاريخ…",
    noMyLicenses: "لم يتم العثور على تراخيص.",
    quotaTab: "الحصة والاستخدام",
    auditTab: "سجلات المراجعة",
    lookupLogsTab: "استعلامات الترخيص",
    lookupLogsLoadError: "تعذر تحميل سجلات استعلام الترخيص. تحقق من صلاحيات Full Admin في Firestore.",
    lookupLogsIntro: "يُحفظ كل استعلام من الموقع العام والبوابة في صف مستقل — حتى تكرار نفس الترخيص. يظهر لمدير المنصة فقط.",
    lookupRepeatCount: "{{count}} استعلامات",
    lookupTotalSummary: "{{total}} استعلام · {{unique}} تراخيص مختلفة",
    lookupLogsSearch: "البحث بالمفتاح أو IP أو المدينة أو الدولة…",
    noLookupLogs: "لا توجد استعلامات ترخيص بعد",
    lookupColTime: "الوقت",
    lookupColKey: "مفتاح الترخيص",
    lookupColStatus: "الحالة",
    lookupColIp: "IP",
    lookupColLocation: "المدينة / الدولة",
    lookupColIsp: "مزود الخدمة",
    lookupColDevice: "الجهاز / الحاسوب",
    lookupColSource: "المصدر",
    lookupRefresh: "تحديث",
    lookupSourcePublic: "الموقع العام",
    lookupSourcePortal: "البوابة",
    lookupSourceMobile: "تطبيق الجوال",
    lookupDetailUa: "وكيل المستخدم",
    lookupDetailLang: "اللغة",
    lookupDetailTz: "المنطقة الزمنية",
    lookupDetailCoords: "الإحداثيات",
    lookupDetailPage: "الصفحة",
    lookupDetailReferrer: "المُحيل",
    lookupStatus_valid: "صالح",
    lookupStatus_expired: "منتهٍ",
    lookupStatus_revoked: "ملغى",
    lookupStatus_pending: "قيد الانتظار",
    lookupStatus_not_found: "غير موجود",
    lookupStatus_invalid_format: "تنسيق غير صالح",
    lookupStatus_error: "خطأ",
    lookupStatus_unknown: "غير معروف",
    loginLogsTab: "سجلات الدخول",
    loginLogsLoadError: "تعذر تحميل سجلات الدخول. تحقق من صلاحيات Full Admin في Firestore.",
    loginLogsIntro: "يُحفظ كل تسجيل دخول ناجح من لوحة الويب وiOS وAndroid في Firebase مع الوقت وعنوان IP ومعلومات الجهاز. يظهر لمدير المنصة فقط.",
    loginLogsSearch: "البحث بالبريد أو IP أو المدينة أو الدولة أو الجهاز…",
    noLoginLogs: "لا توجد سجلات دخول بعد",
    loginColUser: "المستخدم",
    loginTotalSummary: "{{total}} عمليات دخول",
    loginSourceWeb: "لوحة الويب",
    loginSourceIos: "iOS",
    loginSourceAndroid: "Android",
    loginDetailDevice: "اسم الجهاز",
    loginDetailOs: "نظام التشغيل",
    usersTab: "المستخدمون والأدوار",
    rolesTab: "صلاحيات الأدوار",
    monthlyQuota: "حصة العمليات الشهرية",
    used: "مستخدم",
    quotaWarning: " ⚠️ اقتراب من حد الحصة!",
    burstCapacity: "سعة الاندفاع: {{count}} عملية",
    storageUsage: "استخدام التخزين",
    concurrentUsers: "المستخدمون المتزامنون",
    active: "نشط",
    limit: "الحد",
    licenseInfo: "1 ترخيص = 20 مستخدم متزامن",
    aiTokenUsage: "استخدام رموز الذكاء الاصطناعي",
    tokens: "{{count}} رمز",
    tokenDesc: "استهلاك معالجة الذكاء الاصطناعي هذا الشهر",
    noAuditLogs: "لا توجد سجلات مراجعة بعد",
    searchUsers: "البحث عن المستخدمين",
    searchUsersPlaceholder: "البريد أو الاسم أو الدور…",
    usersHierarchyHelp: "التسلسل: Full Admin → Admin → Company → Dealer → User → Viewer. عيّن الحساب الأب لربط الهيكل.",
    user: "المستخدم",
    role: "الدور",
    parent: "الحساب الأب",
    noParent: "بدون أب",
    parentHelp: "الحساب الأب يحدد الهيكل التنظيمي (مثلاً Dealer تحت Company).",
    actions: "الإجراءات",
    noUsers: "لا يوجد مستخدمون.",
    editRole: "تعديل الدور",
    addUser: "إضافة مستخدم",
    addUserHelp: "إنشاء حسابات Admin أو Company أو Dealer أو User أو Viewer. يمكن إضافة بيانات الشركة لـ Admin و Company. لا يمكن إنشاء Full Admin من هنا.",
    createUser: "إنشاء مستخدم",
    addDisplayName: "الاسم الكامل",
    addDisplayNamePlaceholder: "مثال: مسؤول شركة Acme",
    addEmail: "البريد الإلكتروني",
    addPassword: "كلمة المرور",
    addConfirmPassword: "تأكيد كلمة المرور",
    addNameRequired: "الاسم الكامل مطلوب (حرفان على الأقل).",
    addEmailRequired: "البريد الإلكتروني مطلوب.",
    addEmailInvalid: "صيغة البريد غير صالحة.",
    addEmailInUse: "هذا البريد مسجل بالفعل.",
    addEmailReserved: "هذا البريد محجوز لـ Full Admin الخاص بالمنصة.",
    addPasswordMin: "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
    addPasswordsNoMatch: "كلمتا المرور غير متطابقتين.",
    userCreated: "تم إنشاء المستخدم {{email}} بدور {{role}}.",
    userCreateError: "فشل إنشاء المستخدم.",
    companyInfoTitle: "معلومات الشركة",
    companyInfoHelp: "مطلوب لدور Admin. يسجّل هذا الحساب كشركة مرخّصة (مختلف عن دور Company).",
    companyInfoRequired: "معلومات الشركة مطلوبة لدور Admin.",
    companyTradeName: "الاسم التجاري",
    companyTradeNamePlaceholder: "الاسم القانوني / التجاري للشركة",
    companyTaxId: "الرقم الضريبي",
    companyTaxIdPlaceholder: "مثال: 1234567890",
    companyAddress: "العنوان",
    companyAddressPlaceholder: "عنوان العمل الكامل",
    companyPhone: "الهاتف",
    companyEmail: "بريد الشركة",
    companyWebsite: "الموقع الإلكتروني",
    companyDiscountRate: "نسبة الخصم (%)",
    companyCountry: "البلد",
    companyCountryPlaceholder: "مثال: تركيا",
    companyCity: "المدينة",
    companyCityPlaceholder: "مثال: إسطنبول",
    companyRegion: "المنطقة",
    companyRegionPlaceholder: "مثال: مرمرة",
    companySectors: "فئات قطاع الخدمة",
    companySectorsHelp: "اختر قطاعاً واحداً أو أكثر (مثل التعبئة، الغذاء).",
    sector_packaging: "التعبئة والتغليف",
    sector_food: "الغذاء",
    sector_electronics: "الإلكترونيات",
    sector_textile: "المنسوجات",
    sector_automotive: "السيارات",
    sector_chemicals: "الكيماويات",
    sector_construction: "البناء",
    sector_pharma: "الأدوية",
    sector_logistics: "اللوجستيات",
    sector_retail: "التجزئة",
    sector_agriculture: "الزراعة",
    sector_other: "أخرى",
    errCompanyTradeName: "الاسم التجاري مطلوب.",
    errCompanyTaxId: "الرقم الضريبي مطلوب.",
    errCompanyAddress: "العنوان مطلوب.",
    errCompanyPhone: "الهاتف مطلوب.",
    errCompanyEmail: "بريد شركة صالح مطلوب.",
    errCompanyCountry: "البلد مطلوب.",
    errCompanyCity: "المدينة مطلوبة.",
    errCompanyRegion: "المنطقة مطلوبة.",
    errCompanySectors: "اختر فئة قطاع واحدة على الأقل.",
    errCompanyDiscount: "يجب أن تكون نسبة الخصم بين 0 و 100.",
    roleUpdated: "تم تحديث دور المستخدم.",
    roleUpdateError: "فشل تحديث الدور.",
    usersLoadError: "فشل تحميل المستخدمين.",
    cannotAssignRole: "لا يمكنك تعيين هذا الدور.",
    cannotEditFullAdmin: "فقط Full Admin يمكنه تعديل حسابات Full Admin.",
    fullAdminLocked: "لا يمكن تخفيض دور البريد الأساسي للمنصة.",
    rolesHelp: "صلاحيات الأدوار مخزّنة في Firestore (مجموعة roles). المزامنة تكتب مصفوفة الصلاحيات الافتراضية.",
    syncRolesFirebase: "مزامنة الأدوار مع Firebase",
    rolesSeeded: "تمت مزامنة {{count}} أدوار مع Firebase.",
    rolesSeedError: "فشلت مزامنة الأدوار.",
    role_full_admin: "مدير كامل الصلاحيات",
    role_admin: "مدير",
    role_company: "شركة",
    role_dealer: "موزّع",
    role_user: "مستخدم",
    role_viewer: "مُطّلع",
    role_auditor: "مدقق / محاسب محلي",
    roleDesc_full_admin: "مالك المنصة — وصول كامل بما في ذلك إدارة المستخدمين والأدوار.",
    roleDesc_admin: "شركة شراء تراخيص بالجملة — يجب إدخال بيانات الشركة؛ إدارة التراخيص ومستخدمي المؤسسة.",
    roleDesc_company: "شركة خارجية مرخّصة — إدارة الموزعين وعمليات الشركة.",
    roleDesc_dealer: "موزع فرعي تحت الشركة — إدارة مستخدمي الموزع.",
    roleDesc_user: "حساب تشغيلي تحت الموزع — قراءة/كتابة للوحدات.",
    roleDesc_viewer: "حساب عرض فقط — بدون صلاحيات كتابة.",
    roleDesc_auditor: "قراءة فقط لفواتير الشركة وحساباتها وكشوفها ومستنداتها."
  },
  notif: {
    title: "الإشعارات",
    titleWithCount: "الإشعارات ({{count}})",
    markAllRead: "تحديد الكل كمقروء",
    justNow: "الآن",
    minAgo: "منذ {{count}} دقيقة",
    hoursAgo: "منذ {{count}} ساعة",
    daysAgo: "منذ {{count}} يوم",
    empty: "لا توجد إشعارات",
    emptyDesc: "ستظهر هنا مشاركات الملفات ونتائج التعرف الضوئي وتحذيرات الحصة."
  },
  licenseRenewal: {
    title: "تجديد الترخيص",
    intro: "اختر التراخيص والكميات التي تريد تجديدها. يُرسل طلبك إلى مزود الترخيص للموافقة.",
    requestButton: "طلب تجديد",
    selectTitle: "التراخيص المراد تجديدها",
    sentTo: "سيتم إرسال الطلب إلى {{seller}}",
    noAdmin: "حسابك غير مرتبط بمزود ترخيص. يرجى التواصل مع الدعم.",
    adminFallback: "مزود الترخيص",
    noLicenses: "لا توجد تراخيص مخصصة لشركتك.",
    currentCount: "{{count}} ترخيص",
    expiredCount: "{{count}} منتهي الصلاحية",
    selectedCount: "{{count}} محدد",
    renewQuantity: "الكمية المراد تجديدها",
    chooseLicenses: "اختر التراخيص",
    hideLicenses: "إخفاء التراخيص",
    selectAll: "تحديد الكل",
    selectExpired: "تحديد المنتهية",
    clearSelection: "مسح",
    summaryTitle: "ملخص الطلب",
    totalQuantity: "الكمية الإجمالية",
    noteLabel: "ملاحظة",
    notePlaceholder: "مدة التجديد، متطلبات إضافية…",
    submit: "إرسال طلب التجديد",
    submitted: "تم إرسال طلب تجديد {{count}} ترخيص.",
    submitError: "تعذر إرسال طلب التجديد. يرجى المحاولة مرة أخرى.",
    nothingSelected: "أدخل كمية لمنتج واحد على الأقل.",
    quantityBelowSelection: "لا يمكن أن تكون كمية {{product}} أقل من عدد التراخيص المحددة.",
    myRequests: "طلبات التجديد الخاصة بي",
    noRequests: "لم ترسل أي طلب تجديد بعد.",
    requestTitle: "طلب تجديد ترخيص",
    requestQuantity: "{{count}} ترخيص",
    items: "التراخيص المطلوبة",
    noSpecificLicenses: "لم يتم تحديد رموز تراخيص معينة.",
    notifyAdmin: "طلبت {{company}} تجديد {{count}} ترخيص."
  },
  support: {
    title: "مركز الدعم",
    subtitle: "تابع طلباتك وتواصل مع فريق الدعم من مكان واحد.",
    newTicket: "تذكرة جديدة",
    loadError: "تعذر تحميل التذاكر. يرجى المحاولة مرة أخرى.",
    searchPlaceholder: "ابحث بالموضوع أو رقم التذكرة أو الشخص",
    backToList: "كل التذاكر",
    justNow: "الآن",
    you: "أنت",
    unread: "رد جديد",
    scope: {
      mine: "التي فتحتها",
      assigned: "المسندة إليّ",
      all: "كل التذاكر",
      public: "طلبات نموذج الويب"
    },
    filter: {
      active: "نشطة",
      unread: "غير مقروءة",
      all: "الكل"
    },
    stats: {
      active: "تذاكر نشطة",
      unread: "ردود جديدة",
      waiting: "بانتظار الرد",
      resolved: "تم حلها"
    },
    status: {
      open: "مفتوحة",
      in_progress: "قيد المعالجة",
      waiting_customer: "بانتظار رد العميل",
      resolved: "تم الحل",
      closed: "مغلقة"
    },
    priority: {
      P1: "P1 · عاجلة",
      P2: "P2 · عالية",
      P3: "P3 · عادية",
      P4: "P4 · منخفضة"
    },
    priorityHint: {
      P1: "توقف العمل تمامًا. استخدمها للأعطال الحرجة فقط.",
      P2: "ميزة مهمة متوقفة لك أو لفريقك.",
      P3: "شيء لا يعمل كما هو متوقع لكن يوجد حل مؤقت.",
      P4: "سؤال عام أو مشكلة بسيطة لا تؤثر على عملك اليومي."
    },
    sla: {
      P1: "خلال ساعتين",
      P2: "خلال 8 ساعات",
      P3: "خلال يوم عمل واحد",
      P4: "خلال 3 أيام عمل"
    },
    periodPriority: {
      month_end: "فترة نهاية الشهر / الإقرارات: تُرفع الطلبات المؤثرة على الإقفال مستوى واحدًا.",
      provisional_tax: "فترة الضريبة المؤقتة: تُرفع الطلبات المؤثرة على الإقفال مستوى واحدًا.",
      raised: "الأولوية {{from}} ← {{to}}."
    },
    mail: {
      ticket: "الطلب",
      priority: "الأولوية",
      category: "الموضوع",
      requester: "مقدم الطلب",
      open: "فتح"
    },
    category: {
      technical: "مشكلة تقنية",
      accounting: "المحاسبة والإقرارات",
      license: "الترخيص",
      billing: "الفواتير والدفع",
      account: "الحساب والوصول",
      feature: "طلب ميزة",
      other: "أخرى"
    },
    categoryDesc: {
      technical: "أخطاء أو توقف أو مشاكل المزامنة والرفع",
      accounting: "الدفاتر والفواتير والإقفال والإقرارات الضريبية",
      license: "التفعيل أو التجديد أو حدود الترخيص",
      billing: "الفواتير والمدفوعات والأسعار",
      account: "تسجيل الدخول وكلمة المرور والمستخدمون والأدوار",
      feature: "أفكار واقتراحات للتحسين",
      other: "أي موضوع آخر تحتاج فيه إلى مساعدة"
    },
    source: {
      web: "بوابة الويب",
      ios: "تطبيق iOS",
      android: "تطبيق Android"
    },
    empty: {
      title: "لا توجد تذاكر بعد",
      desc: "عندما تحتاج إلى مساعدة، افتح تذكرة وتابع المحادثة هنا.",
      filteredTitle: "لا توجد تذاكر مطابقة",
      filteredDesc: "جرّب عامل تصفية أو بحثًا مختلفًا.",
      clearFilters: "مسح عوامل التصفية"
    },
    public: {
      emptyTitle: "لا توجد طلبات من نموذج الويب",
      emptyDesc: "ستظهر هنا الطلبات المرسلة من نموذج الدعم في صفحة تسجيل الدخول.",
      intro: "طلبات أرسلها الزوار من نموذج الدعم في صفحة تسجيل الدخول. رد عبر البريد الإلكتروني ثم ضع علامة تم.",
      reply: "رد",
      replySubject: "طلب الدعم الخاص بك في FutureDocs",
      markDone: "تم",
      reopen: "إعادة فتح"
    },
    form: {
      title: "فتح تذكرة دعم",
      subtitle: "أخبرنا بما حدث؛ التفاصيل الواضحة تساعدنا على الحل بشكل أسرع.",
      categoryStep: "في أي موضوع تحتاج إلى مساعدة؟",
      categoryRequired: "يرجى اختيار موضوع.",
      detailsStep: "صف المشكلة",
      subject: "الموضوع",
      subjectPlaceholder: "مثال: لا يمكن تنزيل ملف PDF للفاتورة",
      subjectRequired: "يرجى إدخال موضوع لا يقل عن 5 أحرف.",
      description: "التفاصيل",
      descriptionPlaceholder: "ماذا كنت تحاول أن تفعل، وماذا حدث بدلاً من ذلك، ومنذ متى؟",
      descriptionRequired: "يرجى كتابة {{count}} حرفًا على الأقل حتى نفهم المشكلة.",
      descriptionHint: "أضف خطوات تكرار المشكلة ورسائل الخطأ والصفحة التي كنت فيها.",
      license: "الترخيص المرتبط",
      optional: "اختياري",
      noLicense: "غير مرتبط بترخيص",
      priorityStep: "ما مدى الاستعجال؟",
      submit: "إرسال التذكرة",
      submitError: "تعذر إنشاء التذكرة. يرجى المحاولة مرة أخرى.",
      routingTitle: "من سيرد؟",
      routingProvider: "فريق دعم مزود الترخيص الخاص بك",
      routingPlatform: "دعم منصة FutureDocs",
      routingDesc: "ستتلقى إشعارًا بكل رد ويمكنك متابعة المحادثة من بوابة الويب أو تطبيق الجوال.",
      tipsTitle: "نصائح لرد سريع",
      tip1: "تذكرة واحدة لكل مشكلة تبقي المحادثة مركزة.",
      tip2: "اكتب رسالة الخطأ بالضبط والخطوات التي أدت إليها.",
      tip3: "اذكر رقم المستند أو الفاتورة أو السجل إن وجد.",
      slaTitle: "الوقت المستهدف لأول رد"
    },
    quick: {
      looking: "شكرًا لتواصلك، نحن نراجع الأمر.",
      needInfo: "هل يمكنك مشاركة لقطة شاشة والخطوات التي تؤدي إلى المشكلة؟",
      fixed: "تم إصلاح المشكلة. هل يمكنك التحقق والتأكيد من جهتك؟"
    },
    detail: {
      sendError: "تعذر إرسال رسالتك. يرجى المحاولة مرة أخرى.",
      statusError: "تعذر تحديث الحالة.",
      copy: "نسخ رقم التذكرة",
      openedAgo: "فُتحت {{time}}",
      createdTitle: "تم إنشاء التذكرة.",
      createdDesc: "رقم تذكرتك {{no}}. سنرسل لك إشعارًا عند وصول رد.",
      statusChanged: "غيّر {{name}} الحالة إلى",
      staffTag: "الدعم",
      sending: "جارٍ الإرسال...",
      closedNote: "هذه التذكرة مغلقة. أعد فتحها إذا عادت المشكلة.",
      replyReopens: "اكتب ردًا؛ سيعيد ذلك فتح التذكرة",
      placeholder: "اكتب رسالة...",
      send: "إرسال",
      shortcut: "Ctrl / Cmd + Enter للإرسال",
      status: "الحالة",
      resolvedPrompt: "هل تم حل مشكلتك؟ أغلق التذكرة أو اكتب ردًا لمتابعة المحادثة.",
      requester: "مقدم الطلب",
      handledBy: "الجهة المسؤولة",
      handledProvider: "دعم مزود الترخيص",
      handledPlatform: "دعم المنصة",
      channel: "القناة",
      created: "تاريخ الإنشاء",
      lastActivity: "آخر نشاط",
      notFound: "التذكرة غير موجودة",
      notFoundDesc: "ربما تم حذفها أو ليس لديك صلاحية الوصول إليها."
    },
    actions: {
      reopen: "إعادة فتح",
      waitCustomer: "انتظار رد العميل",
      resolve: "وضع علامة تم الحل",
      markSolved: "تم حل مشكلتي",
      close: "إغلاق التذكرة"
    }
  },
  nav: {
    trash: "سلة المحذوفات",
    home: "الرئيسية",
    files: "الملفات",
    search: "البحث",
    settingsTab: "الإعدادات",
    myFiles: "ملفاتي",
    fileDetail: "تفاصيل الملف",
    uploadFile: "رفع ملف",
    folderManagement: "إدارة المجلدات",
    shareFile: "مشاركة الملف",
    filePreview: "معاينة الملف",
    versionHistory: "سجل الإصدارات",
    profile: "الملف الشخصي",
    notifications: "الإشعارات",
    adminPanel: "لوحة الإدارة",
    licenseRenewal: "تجديد الترخيص",
    support: "الدعم",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة",
    kvkk: "نص توضيح KVKK",
    distanceSales: "عقد البيع عن بُعد",
    deliveryConditions: "شروط التسليم والخدمة",
    cancellationReturn: "الإلغاء والاسترداد والعدول",
    aiAssistant: "مساعد الذكاء الاصطناعي",
    ocrResult: "نتيجة التعرف الضوئي"
  },
  workspace: {
    selectWorkspace: "اختر مساحة العمل",
    selectWorkspaceDesc: "اختر مساحة عمل للمتابعة",
    switched: "تم تبديل مساحة العمل",
    switchedTo: "أنت الآن تستخدم {{name}}",
    loadError: "فشل تحميل مساحات العمل",
    switchError: "فشل تبديل مساحة العمل",
    roleOwner: "مالك",
    roleAdmin: "مسؤول",
    roleMember: "عضو",
    roleViewer: "مشاهد",
    joinWorkspace: "الانضمام لمساحة عمل",
    joinWorkspaceDesc: "أدخل رمز الدعوة أو تواصل مع المسؤول",
    currentWorkspace: "مساحة العمل الحالية",
    switchWorkspace: "تبديل مساحة العمل"
  },
  languages: {
    en: "English",
    ar: "العربية",
    selectLanguage: "اختر اللغة"
  },
  network: {
    offline: "أنت غير متصل بالإنترنت. قد تكون بعض الميزات غير متاحة.",
    weak: "تم اكتشاف اتصال إنترنت ضعيف.",
    restored: "تم استعادة الاتصال!",
    offlineMode: "وضع عدم الاتصال",
    syncPending: "{{count}} تغييرات في انتظار المزامنة"
  },
  security: {
    twoFactorAuth: "المصادقة الثنائية",
    sessionHistory: "سجل الجلسات"
  },
  errorBoundary: {
    title: "حدث خطأ غير متوقع",
    message: "واجه التطبيق خطأً غير متوقع. يرجى المحاولة مرة أخرى.",
    retry: "إعادة المحاولة"
  },
  legal: {
    lastUpdated: "آخر تحديث: يناير 2026",
    privacyPolicy: {
      title: "سياسة الخصوصية",
      section1Title: "1. جمع البيانات",
      section1: "يجمع Future Document فقط البيانات اللازمة لتقديم خدمات إدارة الملفات السحابية. يشمل ذلك اسمك وبريدك الإلكتروني والمستندات المرفوعة.",
      section2Title: "2. تخزين البيانات",
      section2: "يتم تخزين جميع البيانات بشكل آمن على بنية Firebase السحابية مع تشفير أثناء الراحة وأثناء النقل.",
      section3Title: "3. استخدام البيانات",
      section3: "تُستخدم بياناتك فقط لتقديم خدماتنا بما في ذلك تخزين المستندات ومعالجة التعرف الضوئي وتحليل المستندات بالذكاء الاصطناعي.",
      section4Title: "4. مشاركة البيانات",
      section4: "لا نبيع أو نشارك بياناتك الشخصية مع أطراف ثالثة إلا وفقاً لما يقتضيه القانون.",
      section5Title: "5. الاحتفاظ بالبيانات",
      section5: "يتم الاحتفاظ بالبيانات طوال مدة حسابك. عند حذف الحساب، يتم إزالة جميع البيانات نهائياً خلال 30 يوماً.",
      section6Title: "6. حقوق المستخدم",
      section6: "لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها في أي وقت من خلال إعدادات حسابك.",
      section7Title: "7. ملفات تعريف الارتباط والتحليلات",
      section7: "نستخدم ملفات تعريف ارتباط أساسية للمصادقة وإدارة الجلسات. يتم جمع بيانات التحليلات بشكل مجهول لتحسين خدماتنا.",
      section8Title: "8. الاتصال",
      section8: "للاستفسارات المتعلقة بالخصوصية، تواصل معنا على"
    },
    termsOfService: {
      title: "شروط الخدمة",
      section1Title: "1. قبول الشروط",
      section1: "باستخدام Future Document، فإنك توافق على شروط الخدمة هذه وسياسة الخصوصية.",
      section2Title: "2. وصف الخدمة",
      section2: "يوفر Future Document إدارة ملفات سحابية للمؤسسات مع معالجة التعرف الضوئي وتحليل المستندات بالذكاء الاصطناعي ومشاركة الملفات الآمنة.",
      section3Title: "3. الترخيص",
      section3: "يلزم رمز ترخيص صالح للتسجيل واستخدام الخدمة. يمنح كل ترخيص وصولاً لما يصل إلى 20 مستخدماً متزامناً.",
      section4Title: "4. مسؤوليات المستخدم",
      section4: "المستخدمون مسؤولون عن الحفاظ على سرية بيانات اعتماد حساباتهم وعن جميع الأنشطة تحت حساباتهم.",
      section5Title: "5. الاستخدامات المحظورة",
      section5: "لا يجوز استخدام الخدمة لأي أغراض غير قانونية أو لرفع محتوى ضار.",
      section6Title: "6. توفر الخدمة",
      section6: "نسعى لتوفير 99.9% من وقت التشغيل ولكن لا نضمن خدمة بدون انقطاع.",
      section7Title: "7. الملكية الفكرية",
      section7: "جميع المحتوى المرفوع من قبل المستخدمين يبقى ملكاً لهم. لا يحتفظ Future Document بأي ملكية على بيانات المستخدمين.",
      section8Title: "8. تحديد المسؤولية",
      section8: "لن تتحمل Future Tech Works مسؤولية أي أضرار غير مباشرة أو عرضية ناتجة عن استخدام خدماتنا.",
      section9Title: "9. الإنهاء",
      section9: "نحتفظ بالحق في تعليق أو إنهاء الحسابات التي تنتهك هذه الشروط."
    }
  },
  service: {
    quotaReached: "تم الوصول إلى حد حصة العمليات الشهرية.",
    quotaWarningTitle: "تحذير الحصة",
    quotaWarningMsg: "لقد استخدمت 80% من حصتك الشهرية ({{used}}/{{limit}})",
    fileSharedTitle: "تمت مشاركة ملف",
    fileSharedMsg: "{{name}} شارك ملفاً معك"
  },
  accounting: {
    title: "المحاسبة",
    invoices: {
      title: "الفواتير",
      totalInvoices: "إجمالي الفواتير",
      totalAmount: "المبلغ الإجمالي",
      paidAmount: "المبلغ المدفوع",
      pendingAmount: "المبلغ المعلق",
      search: "البحث في الفواتير...",
      allStatuses: "جميع الحالات",
      allTypes: "جميع الأنواع",
      newInvoice: "فاتورة جديدة",
      noInvoices: "لا توجد فواتير بعد",
      createFirst: "أنشئ أول فاتورة",
      invoiceNo: "رقم الفاتورة",
      type: "النوع",
      typeManual: "يدوي",
      customer: "العميل",
      vendor: "المورد",
      date: "التاريخ",
      dueDate: "تاريخ الاستحقاق",
      issueDate: "تاريخ الفاتورة",
      paidDateLabel: "تاريخ الدفع",
      status: "الحالة",
      statusDraft: "مسودة",
      statusPending: "قيد الانتظار",
      statusApproved: "معتمد",
      statusPaid: "مدفوع",
      statusCancelled: "ملغي",
      lineItems: "بنود الفاتورة",
      description: "الوصف",
      descriptionPlaceholder: "وصف المنتج أو الخدمة",
      quantity: "الكمية",
      unitPrice: "سعر الوحدة",
      taxRateLabel: "% الضريبة",
      lineTotal: "الإجمالي",
      subtotal: "المجموع الفرعي",
      tax: "الضريبة",
      grandTotal: "الإجمالي الكلي",
      addItem: "إضافة بند",
      summary: "الملخص",
      quickInfo: "معلومات سريعة",
      itemCount: "{{count}} بند",
      invoiceInfo: "معلومات الفاتورة",
      currency: "العملة",
      vendorPlaceholder: "اسم المورد / المزود",
      customerPlaceholder: "اسم العميل / الشركة",
      timeline: "مسار الحالة",
      current: "الحالي",
      relatedFiles: "الملفات ذات الصلة",
      noRelatedFiles: "لا توجد ملفات مرتبطة",
      actions: "الإجراءات",
      overdue: "متأخر",
      overdueMsg: "هذه الفاتورة تجاوزت تاريخ استحقاقها.",
      notFound: "الفاتورة غير موجودة.",
      loadError: "فشل تحميل الفاتورة.",
      deleteTitle: "حذف الفاتورة",
      deleteMsg: "هل أنت متأكد من حذف الفاتورة \"{{no}}\"؟",
      demoDelete: "الحذف معطل في الوضع التجريبي.",
      demoSave: "تم حفظ الفاتورة في الوضع التجريبي.",
      saveError: "فشل حفظ الفاتورة.",
      invoiceNoRequired: "رقم الفاتورة مطلوب.",
      partyRequired: "يرجى إدخال اسم المورد أو العميل.",
      itemsRequired: "يجب أن تحتوي جميع البنود على وصف وكمية وسعر الوحدة."
    },
    accounts: {
      title: "الحسابات الجارية",
      totalAccounts: "إجمالي الحسابات",
      totalReceivable: "إجمالي المستحقات",
      totalPayable: "إجمالي المدفوعات",
      customersVendors: "العملاء / الموردون",
      search: "البحث في الحسابات...",
      allTypes: "جميع الأنواع",
      allBalances: "جميع الأرصدة",
      balancePositive: "مستحق (موجب)",
      balanceNegative: "مدين (سالب)",
      balanceZero: "متوازن (صفر)",
      newAccount: "حساب جديد",
      noAccounts: "لا توجد حسابات بعد",
      createFirst: "أنشئ أول حساب",
      name: "الاسم",
      type: "النوع",
      typeCustomer: "عميل",
      typeVendor: "مورد",
      taxId: "الرقم الضريبي",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      address: "العنوان",
      balance: "الرصيد",
      tags: "العلامات",
      accountInfo: "معلومات الحساب",
      peppolId: "معرّف Peppol / الفاتورة الإلكترونية",
      currency: "العملة",
      creditLimit: "حد الائتمان",
      paymentTermDays: "مدة السداد (أيام)",
      daysValue: "{{count}} يوم",
      taxClass: "الفئة الضريبية",
      creditExceeded: "تم تجاوز حد الائتمان",
      taxClasses: { standard: "قياسي", reduced: "مخفّض", zero: "بنسبة صفر", exempt: "معفى", reverse: "احتساب عكسي" },
      errors: { required: "مطلوب", peppol: "استخدم الصيغة scheme:id مثل 0088:5790000435951", nonNegative: "يجب أن يكون صفرًا أو أكثر", days: "عدد أيام صحيح بين 0 و365", enum: "قيمة غير صالحة" },
      balanceSummary: "ملخص الرصيد",
      receivable: "مستحق",
      payable: "مدين",
      balanced: "متوازن",
      totalDebit: "إجمالي المدين",
      totalCredit: "إجمالي الدائن",
      transactionHistory: "سجل الحركات",
      noTransactions: "لا توجد حركات بعد",
      newTransaction: "حركة جديدة",
      txType: "نوع الحركة",
      txDate: "التاريخ",
      txDescription: "الوصف",
      txDescriptionPlaceholder: "دفعة، فاتورة، إلخ.",
      txDebit: "مدين",
      txCredit: "دائن",
      txAmount: "المبلغ",
      txInvoice: "الفاتورة",
      txInvoicePlaceholder: "معرف الفاتورة (اختياري)",
      relatedContracts: "العقود المرتبطة",
      noContracts: "لا توجد عقود مرتبطة",
      paymentPlan: "خطة الدفع",
      noPaymentPlan: "لا توجد خطة دفع",
      installment: "القسط",
      actions: "الإجراءات",
      notFound: "الحساب غير موجود.",
      loadError: "فشل تحميل الحساب.",
      deleteTitle: "حذف الحساب",
      deleteMsg: "هل أنت متأكد من حذف الحساب \"{{name}}\"؟",
      demoDelete: "الحذف معطل في الوضع التجريبي."
    },
    approvals: {
      title: "الموافقات",
      pendingApprovals: "الموافقات المعلقة",
      sentRequests: "الطلبات المرسلة",
      approvedCount: "الموافق عليها",
      rejectedCount: "المرفوضة",
      search: "بحث في الموافقات…",
      allStatuses: "جميع الحالات",
      newRequest: "طلب جديد",
      tabPending: "موافقاتي المعلقة",
      tabSent: "طلباتي",
      noPending: "لا توجد موافقات معلقة.",
      noSent: "لم تقدم أي طلبات.",
      requestTitle: "العنوان",
      type: "النوع",
      typeExpense: "مصروف",
      typePayment: "دفعة",
      typeInvoice: "فاتورة",
      requestedBy: "مقدم الطلب",
      currentApprover: "الموافق الحالي",
      amount: "المبلغ",
      currency: "العملة",
      date: "التاريخ",
      status: "الحالة",
      statusPending: "معلق",
      statusInReview: "قيد المراجعة",
      statusApproved: "موافق عليه",
      statusRejected: "مرفوض",
      requestInfo: "تفاصيل الطلب",
      description: "الوصف",
      descriptionPlaceholder: "صف سبب هذا الطلب…",
      titlePlaceholder: "مثال: شراء مستلزمات المكتب",
      titleRequired: "العنوان مطلوب.",
      noApprover: "لم يتم العثور على معتمِد: حسابك غير مرتبط بحساب أعلى. اطلب من المسؤول ربطه.",
      selfApprovalForbidden: "لا يمكنك الموافقة على طلبك أو رفضه.",
      amountRequired: "المبلغ مطلوب.",
      relatedInvoice: "الفاتورة المرتبطة",
      invoicePlaceholder: "رقم الفاتورة (اختياري)",
      thresholdInfo: "حدود الموافقة",
      tierManager: "المدير فقط",
      tierManagerDirector: "المدير + المدير التنفيذي",
      tierManagerDirectorCFO: "المدير + المدير التنفيذي + المدير المالي",
      submit: "تقديم للموافقة",
      demoSubmit: "تم تقديم الطلب (وضع تجريبي).",
      submitError: "فشل تقديم الطلب.",
      notFound: "طلب الموافقة غير موجود.",
      loadError: "فشل تحميل الطلب.",
      approvalChain: "سلسلة الموافقة",
      noChain: "لم يتم تكوين سلسلة موافقة.",
      awaitingApproval: "في الانتظار",
      chainProgress: "التقدم",
      relatedResources: "الموارد المرتبطة",
      noRelated: "لا توجد موارد مرتبطة.",
      actions: "الإجراءات",
      approve: "موافقة",
      reject: "رفض",
      approveTitle: "الموافقة على الطلب",
      rejectTitle: "رفض الطلب",
      note: "ملاحظة",
      notePlaceholder: "ملاحظة اختيارية لمقدم الطلب…",
      approvedMsg: "تمت الموافقة على الطلب بنجاح.",
      rejectedMsg: "تم رفض الطلب."
    }
  },
  inventory: {
    title: "المستودع / المخزون",
    totalProducts: "إجمالي المنتجات",
    criticalStockCount: "مخزون حرج",
    totalStockValue: "قيمة المخزون",
    categories: "الفئات",
    searchPlaceholder: "بحث بالاسم أو SKU أو الباركود…",
    allCategories: "جميع الفئات",
    newProduct: "منتج جديد",
    noProducts: "لم يتم العثور على منتجات.",
    criticalStock: "حرج",
    sku: "SKU",
    barcode: "الباركود",
    trade: { title: "بيانات التجارة واللوجستيات", barcodes: "أرقام GTIN / باركود إضافية", barcodesHelp: "افصل بينها بفواصل. يتم التحقق من رقم التحقق لـ GTIN-8/12/13/14.", gtins: "GTIN / الباركود", hsCode: "رمز النظام المنسق HS", originCountry: "بلد المنشأ (ISO)", dimensions: "الأبعاد (ط × ع × ار)", lengthCm: "الطول (سم)", widthCm: "العرض (سم)", heightCm: "الارتفاع (سم)", netWeightKg: "الوزن الصافي (كغ)", grossWeightKg: "الوزن الإجمالي (كغ)", fixErrors: "يرجى تصحيح حقول التجارة واللوجستيات.", errors: { gtin: "رقم التحقق لـ GTIN غير صحيح", tooLong: "الباركود طويل جدًا", hsCode: "يجب أن يتكون رمز HS من 6 إلى 12 رقمًا", country: "استخدم رمز دولة ISO من حرفين مثل TR", nonNegative: "يجب أن يكون صفرًا أو أكثر", grossBelowNet: "لا يمكن أن يقل الوزن الإجمالي عن الصافي", saveFailed: "تعذر حفظ التغييرات." } },
    partyCodes: { title: "رموز المنتج لدى العملاء / الموردين", row: "الصف {{n}}", empty: "لا توجد رموز شركاء بعد.", partyType: "نوع الشريك", partyName: "الشريك", code: "رمز الشريك", description: "وصف الشريك", customer: "عميل", supplier: "مورد", linked: "مرتبط ببطاقة حساب", add: "إضافة رمز", errors: { required: "املأ الشريك والرمز", duplicate: "هذا الرمز مدرج بالفعل لهذا الشريك", saveFailed: "تعذر حفظ الرموز." } },
    productName: "اسم المنتج",
    category: "الفئة",
    currentStock: "المخزون",
    costPrice: "سعر التكلفة",
    salePrice: "سعر البيع",
    updated: "التحديث",
    unit: "الوحدة",
    description: "الوصف",
    descriptionPlaceholder: "وصف المنتج…",
    serialTracking: "تتبع الرقم التسلسلي",
    lotTracking: "تتبع الدُفعة",
    tags: "العلامات",
    tagsPlaceholder: "مثال: مستورد، هش",
    currency: "العملة",
    images: "الصور",
    uploadImages: "رفع صور",
    chooseFiles: "اختر الملفات…",
    productInfo: "معلومات المنتج",
    stockLevel: "مستوى المخزون",
    current: "الحالي",
    technicalDocs: "المستندات الفنية",
    noDocs: "لا توجد مستندات فنية.",
    certificates: "الشهادات",
    noCertificates: "لا توجد شهادات.",
    stockMovements: "حركات المخزون",
    noMovements: "لا توجد حركات مخزون.",
    movementType: "النوع",
    quantity: "الكمية",
    previousStock: "السابق",
    newStockLevel: "المستوى الجديد",
    note: "ملاحظة",
    notePlaceholder: "سبب تغيير المخزون…",
    date: "التاريخ",
    stockIn: "إدخال مخزون",
    stockOut: "إخراج مخزون",
    stockInTitle: "إدخال مخزون",
    stockOutTitle: "إخراج مخزون",
    stockInSuccess: "تم تسجيل إدخال المخزون.",
    stockOutSuccess: "تم تسجيل إخراج المخزون.",
    currentStockLabel: "المخزون الحالي",
    insufficientStock: "الكمية تتجاوز المخزون الحالي!",
    actions: "الإجراءات",
    deleteTitle: "حذف المنتج",
    deleteMsg: "هل أنت متأكد من حذف \"{{name}}\"؟",
    demoDelete: "الحذف معطل في الوضع التجريبي.",
    notFound: "المنتج غير موجود.",
    loadError: "فشل تحميل المنتج.",
    overview: "نظرة عامة",
    basicInfo: "المعلومات الأساسية",
    pricingStock: "التسعير والمخزون",
    minStockLevel: "الحد الأدنى للمخزون",
    maxStockLevel: "الحد الأقصى للمخزون",
    manualSKU: "إدخال يدوي",
    autoSKU: "توليد تلقائي",
    nameRequired: "اسم المنتج مطلوب.",
    skuRequired: "SKU مطلوب.",
    documents: "المستندات",
    technicalDocIds: "معرفات المستندات الفنية",
    docIdsPlaceholder: "doc-1, doc-2",
    docIdsHelp: "معرفات الملفات مفصولة بفواصل.",
    certificateIds: "معرفات الشهادات",
    certIdsPlaceholder: "cert-1, cert-2",
    certIdsHelp: "معرفات الملفات مفصولة بفواصل.",
    summary: "ملخص",
    save: "حفظ",
    demoCreate: "تم إنشاء المنتج (وضع تجريبي).",
    createError: "فشل إنشاء المنتج.",
    namePlaceholder: "مثال: Dell PowerEdge R750",
    cat_electronics: "إلكترونيات",
    cat_office: "مستلزمات مكتبية",
    cat_furniture: "أثاث",
    cat_raw_material: "مواد خام",
    cat_packaging: "تغليف",
    cat_spare_parts: "قطع غيار",
    cat_consumables: "مستهلكات",
    cat_other: "أخرى"
  },
  movements: {
    title: "حركات المخزون",
    search: "البحث في الحركات...",
    allTypes: "جميع الأنواع",
    allProducts: "جميع المنتجات",
    newEntry: "حركة جديدة",
    dateFrom: "من تاريخ",
    dateTo: "إلى تاريخ",
    clearFilters: "مسح الفلاتر",
    noMovements: "لم يتم العثور على حركات مخزون.",
    totalIn: "إجمالي الوارد",
    totalOut: "إجمالي الصادر",
    transfers: "التحويلات",
    adjustments: "التعديلات",
    date: "التاريخ",
    product: "المنتج",
    type: "النوع",
    type_in: "إدخال مخزون",
    type_out: "إخراج مخزون",
    type_transfer: "تحويل",
    type_adjustment: "تعديل",
    quantity: "الكمية",
    unitCost: "تكلفة الوحدة",
    reason: "السبب / ملاحظة",
    warehouse: "المستودع",
    documentNo: "رقم المستند",
    from: "من",
    to: "إلى",
    movementType: "نوع الحركة",
    productSelection: "المنتج والكمية",
    productSearchPlaceholder: "البحث بالاسم أو SKU أو الباركود...",
    productRequired: "يرجى اختيار منتج.",
    quantityRequired: "يجب أن تكون الكمية أكبر من 0.",
    warehouseRequired: "مستودعات المصدر والوجهة مطلوبة للتحويلات.",
    currentStockLabel: "المخزون الحالي",
    lotNumber: "رقم الدفعة",
    serialNumbers: "الأرقام التسلسلية",
    serialPlaceholder: "SN-001, SN-002, ...",
    serialHelp: "أرقام تسلسلية مفصولة بفواصل.",
    sourceWarehouse: "مستودع المصدر",
    destWarehouse: "مستودع الوجهة",
    warehousePlaceholder: "مثال: المستودع الرئيسي",
    reasonPlaceholder: "سبب الحركة أو ملاحظة...",
    relatedInvoice: "معرف الفاتورة المرتبطة",
    invoicePlaceholder: "inv-...",
    shipmentDocs: "مستندات الشحن",
    addDoc: "إضافة جديد",
    noExistingDocs: "لا توجد مستندات شحن متاحة.",
    newShipmentDoc: "مستند شحن جديد",
    chooseFile: "اختر ملف...",
    summary: "ملخص",
    estimatedStock: "المخزون الجديد المقدر",
    totalCost: "التكلفة الإجمالية",
    save: "حفظ الحركة",
    demoSuccess: "تم تسجيل الحركة (وضع تجريبي).",
    submitError: "فشل تسجيل الحركة."
  },
  shipments: {
    title: "مستندات الشحن",
    search: "البحث في المستندات...",
    allTypes: "جميع الأنواع",
    totalDocs: "إجمالي المستندات",
    waybills: "بوالص الشحن",
    packingLists: "قوائم التعبئة",
    deliveryNotes: "إشعارات التسليم",
    noDocs: "لم يتم العثور على مستندات شحن.",
    newDoc: "مستند جديد",
    documentNo: "رقم المستند",
    docType: "نوع المستند",
    type_waybill: "بوليصة شحن",
    type_packingList: "قائمة تعبئة",
    type_deliveryNote: "إشعار تسليم",
    vendor: "المورد / الناقل",
    vendorPlaceholder: "مثال: DHL, UPS...",
    date: "التاريخ",
    relatedMovements: "الحركات المرتبطة",
    movements: "حركة/حركات",
    file: "ملف",
    view: "عرض",
    noFile: "لا يوجد ملف",
    created: "تم الإنشاء",
    create: "إنشاء",
    docNoRequired: "رقم المستند مطلوب.",
    demoCreate: "تم إنشاء مستند الشحن (وضع تجريبي).",
    createError: "فشل إنشاء المستند."
  },
  purchaseRequests: {
    title: "طلبات الشراء",
    search: "البحث في الطلبات...",
    allStatuses: "جميع الحالات",
    total: "إجمالي الطلبات",
    pending: "قيد الانتظار",
    ordered: "تم الطلب",
    received: "تم الاستلام",
    noRequests: "لم يتم العثور على طلبات شراء. قم بفحص المخزون لاكتشاف العناصر الحرجة.",
    scanStock: "فحص مستويات المخزون",
    noAlerts: "جميع مستويات المخزون سليمة — لم يتم اكتشاف عناصر حرجة.",
    scanResult: "تم اكتشاف {{count}} منتج(ات) حرجة، تم إنشاء {{created}} طلب(ات) شراء.",
    scanError: "فشل فحص مستويات المخزون.",
    product: "المنتج",
    currentStock: "المخزون الحالي",
    minLevel: "الحد الأدنى",
    suggestedQty: "الكمية المقترحة",
    estCost: "التكلفة المقدرة",
    status: "الحالة",
    created: "تم الإنشاء",
    status_auto_generated: "تم الإنشاء تلقائياً",
    status_submitted: "تم الإرسال",
    status_ordered: "تم الطلب",
    status_received: "تم الاستلام",
    actionSubmit: "إرسال",
    actionOrder: "تحديد كطلب",
    actionReceive: "استلام",
    completed: "مكتمل",
    receiveTitle: "استلام المخزون",
    newStock: "المخزون الجديد",
    receivedQty: "الكمية المستلمة",
    receiveHelp: "أدخل الكمية المستلمة الفعلية. سيتم إنشاء حركة إدخال مخزون تلقائياً.",
    confirmReceive: "تأكيد الاستلام",
    receiveSuccess: "تم استلام {{qty}} وحدة من {{product}} وتحديث المخزون.",
    receiveError: "فشل استلام المخزون."
  },
  criticalStock: {
    title: "المخزون الحرج",
    products: "منتج(ات)",
    noCritical: "جميع مستويات المخزون سليمة",
    viewAll: "عرض الطلبات"
  },
  serialTracking: {
    title: "تتبع الأرقام التسلسلية",
    total: "إجمالي التسلسلي",
    inStock: "في المخزون",
    sold: "مباع",
    warranty: "قيد الضمان",
    returned: "مُرتجع",
    scrapped: "خردة",
    search: "بحث عن رقم تسلسلي…",
    allStatuses: "جميع الحالات",
    status_in_stock: "في المخزون",
    status_sold: "مباع",
    status_warranty: "قيد الضمان",
    status_returned: "مُرتجع",
    status_scrapped: "خردة",
    serialNo: "الرقم التسلسلي",
    status: "الحالة",
    purchaseDate: "تاريخ الشراء",
    warrantyExpiry: "انتهاء الضمان",
    customer: "العميل",
    history: "السجل",
    events: "حدث(أحداث)",
    addSerial: "إضافة رقم تسلسلي",
    noSerials: "لم يتم العثور على أرقام تسلسلية.",
    serialRequired: "الرقم التسلسلي مطلوب.",
    demoCreate: "تم إنشاء الرقم التسلسلي (وضع تجريبي).",
    createError: "تعذر إنشاء الرقم التسلسلي.",
    create: "إنشاء",
    movementHistory: "سجل الحركات",
    noHistory: "لا يوجد سجل بعد.",
    relatedFiles: "الملفات المرتبطة",
    warrantyExpired: "منتهي",
    daysLeft: "يوم متبقي",
    customerPlaceholder: "اسم العميل / الشركة",
    tab: "الأرقام التسلسلية",
    viewAll: "عرض جميع الأرقام التسلسلية"
  },
  lotTracking: {
    title: "تتبع الدفعات",
    totalLots: "إجمالي الدفعات",
    active: "نشط",
    expiringSoon: "تنتهي قريباً",
    critical: "حرجة",
    search: "بحث عن رقم دفعة…",
    allStatuses: "جميع الحالات",
    status_active: "نشط",
    status_expired: "منتهي الصلاحية",
    status_recalled: "مسترجع",
    lotNumber: "رقم الدفعة",
    status: "الحالة",
    quantity: "الكمية",
    manufacturingDate: "تاريخ التصنيع",
    expiryDate: "تاريخ انتهاء الصلاحية",
    supplier: "المورد",
    qualityCert: "شهادة الجودة",
    viewCert: "عرض الشهادة",
    addLot: "إضافة دفعة",
    noLots: "لم يتم العثور على دفعات.",
    lotRequired: "رقم الدفعة مطلوب.",
    demoCreate: "تم إنشاء الدفعة (وضع تجريبي).",
    createError: "تعذر إنشاء الدفعة.",
    create: "إنشاء",
    expired: "منتهي الصلاحية",
    daysLeft: "يوم متبقي",
    criticalAlert: "حرج",
    lotsExpiredOrCritical: "دفعة(ات) منتهية أو ستنتهي خلال 7 أيام",
    warningAlert: "تحذير",
    lotsExpiring30: "دفعة(ات) ستنتهي خلال 30 يوماً",
    supplierPlaceholder: "اسم المورد",
    qualityCertFileId: "معرّف ملف شهادة الجودة",
    certIdPlaceholder: "معرّف الملف من المستندات",
    tab: "الدفعات",
    viewAll: "عرض جميع الدفعات"
  },
  session: {
    expiringTitle: "جلستك على وشك الانتهاء",
    expiringBody: "سيتم تسجيل خروجك خلال {{seconds}} ثانية بسبب عدم النشاط.",
    stay: "البقاء متصلاً",
    signOutNow: "تسجيل الخروج",
    timedOut: "تم تسجيل خروجك بعد فترة من عدم النشاط. يرجى تسجيل الدخول مرة أخرى.",
    disabled: "تم تعطيل حسابك. يرجى التواصل مع المسؤول.",
    sessionLimit: "تم الوصول إلى الحد الأقصى للجلسات المتزامنة. سجّل الخروج من جهاز آخر وحاول مرة أخرى.",
    revoked: "تم إنهاء جلستك من مكان آخر."
  },
  exchangeRates: {
    title: "أسعار الصرف",
    subtitle: "جدول أسعار يدوي مقابل {{base}}؛ تستخدم الفاتورة سعر تاريخ السعر.",
    formTitle: "إضافة سعر أو تحديثه",
    listTitle: "الأسعار",
    date: "التاريخ",
    currency: "العملة",
    rateType: "نوع السعر",
    source: "المصدر",
    buy: "شراء",
    sell: "بيع",
    average: "متوسط",
    note: "ملاحظة",
    averageHint: "اترك المتوسط فارغًا لاستخدام متوسط الشراء والبيع. حفظ نفس التاريخ والعملة والنوع يستبدل السعر.",
    allCurrencies: "كل العملات",
    empty: "لم يتم إدخال أسعار بعد",
    saved: "تم حفظ السعر.",
    loadError: "تعذر تحميل الأسعار.",
    saveError: "تعذر حفظ السعر.",
    confirmDelete: "حذف سعر {{currency}} بتاريخ {{date}}؟",
    types: { forex: "تحويل (عملات)", banknote: "نقدي", custom: "مخصص" },
    sides: { buy: "شراء", sell: "بيع", average: "متوسط" },
    errors: { date: "أدخل تاريخًا صالحًا", currency: "اختر عملة", sameAsBase: "يجب أن تختلف عن العملة الأساسية", enum: "قيمة غير صالحة", source: "أدخل المصدر (40 حرفًا كحد أقصى)", positive: "يجب أن يكون أكبر من صفر", sellBelowBuy: "لا يمكن أن يقل سعر البيع عن الشراء", tooLong: "طويل جدًا" },
    invoice: { title: "سعر الصرف", rateDate: "تاريخ السعر", side: "السعر المستخدم", found: "{{currency}}/{{base}} {{value}} ({{source}}، {{date}})", fallback: "لا يوجد سعر في {{requested}}؛ يُستخدم أحدث سعر سابق ({{date}}).", missing: "لا يوجد سعر {{currency}} في {{date}} أو قبله. أضفه إلى جدول الأسعار أولًا.", baseTotal: "الإجمالي بـ {{base}}" }
  },
  privacyRequests: {
    title: "طلبات البيانات الشخصية (KVKK / GDPR)",
    subtitle: "مارس حقوقك على بياناتك الشخصية؛ يُرد على الطلبات ضمن المهلة القانونية.",
    newTitle: "طلب جديد",
    type: "نوع الطلب",
    regime: "القانون المطبق",
    details: "التفاصيل",
    detailsPlaceholder: "ما البيانات وما الذي تريد منا فعله (مثل الحقل المراد تصحيحه أو صيغة التصدير).",
    submit: "إرسال الطلب",
    submitted: "تم استلام الطلب {{no}}. سيتم الرد خلال {{days}} يومًا.",
    submitError: "تعذر إرسال الطلب.",
    saveError: "تعذر حفظ التغيير.",
    deadlineNote: "المهلة القانونية: {{days}} يومًا من الاستلام (KVKK المادة 13، GDPR المادة 12). بموجب GDPR يمكن تمديدها مرة واحدة {{extra}} يومًا مع ذكر السبب.",
    mineTitle: "طلباتي",
    emptyMine: "لم تقدم أي طلب بعد.",
    queueTitle: "قائمة الطلبات",
    emptyQueue: "لا توجد طلبات للمعالجة.",
    openCount: "{{count}} مفتوح",
    overdueCount: "{{count}} متأخر",
    no: "الرقم",
    statusLabel: "الحالة",
    received: "تاريخ الاستلام",
    deadline: "الموعد النهائي",
    requester: "مقدم الطلب",
    withdraw: "سحب",
    confirmWithdraw: "هل تريد سحب هذا الطلب؟",
    overdue: "متأخر ({{date}})",
    daysLeft: "متبقٍ {{count}} يوم ({{date}})",
    daysLeft_one: "متبقٍ يوم واحد ({{date}})",
    types: {
      access: "الوصول",
      rectification: "التصحيح",
      erasure: "المحو",
      portability: "قابلية النقل"
    },
    typeDesc: {
      access: "اعرف ما إذا كانت بياناتك تُعالج وكيف، واحصل على نسخة منها.",
      rectification: "صحّح البيانات الناقصة أو غير الدقيقة.",
      erasure: "احذف أو أخفِ هوية البيانات التي لم تعد مطلوبة.",
      portability: "احصل على بياناتك بصيغة قابلة للقراءة آليًا."
    },
    regimes: {
      kvkk: "KVKK (تركيا)",
      gdpr: "GDPR (الاتحاد الأوروبي)"
    },
    status: {
      received: "مستلم",
      in_review: "قيد المراجعة",
      completed: "مكتمل",
      rejected: "مرفوض",
      withdrawn: "مسحوب"
    },
    errors: {
      type: "اختر نوع الطلب.",
      tooShort: "يرجى وصف الطلب (10 أحرف على الأقل).",
      tooLong: "طويل جدًا."
    },
    handle: {
      open: "معالجة",
      note: "الرد على مقدم الطلب",
      noteHint: "يظهر لمقدم الطلب. يجب ذكر سبب الرفض.",
      reasonRequired: "يجب ذكر سبب الرفض.",
      extend: "تمديد المهلة {{days}} يومًا (GDPR المادة 12/3)",
      extensionReason: "سبب التمديد",
      extensionReasonRequired: "اذكر سبب التمديد."
    }
  },
  auditLog: {
    title: "سجل التدقيق",
    scopeAll: "جميع السجلات على المنصة (المستخدم، الإجراء، الكيان، القيمة السابقة/الجديدة).",
    scopeMine: "سجلاتك وسجلات المستخدمين الذين تديرهم.",
    from: "من",
    to: "إلى",
    user: "المستخدم",
    allUsers: "جميع المستخدمين",
    action: "الإجراء",
    allActions: "جميع الإجراءات",
    entityType: "نوع الكيان",
    entity: "الكيان",
    apply: "تطبيق",
    search: "البحث في النتائج…",
    count: "{{count}} سجل",
    exportCsv: "تنزيل CSV",
    exportJsonl: "تنزيل JSON Lines (SIEM)",
    exportCef: "تنزيل CEF (SIEM)",
    exportMenu: "تصدير",
    emptyTitle: "لم يتم العثور على سجلات",
    emptyBody: "لا توجد سجلات تدقيق تطابق عوامل التصفية المحددة.",
    when: "الوقت",
    previous: "السابق",
    next: "الجديد",
    loadMore: "تحميل المزيد",
    loadFailed: "تعذّر تحميل سجلات التدقيق."
  },
  cookies: {
    bannerText: "نستخدم ملفات تعريف الارتباط الضرورية لتسجيل الدخول والأمان. بإذنك نجمع أيضًا إحصاءات استخدام مجهولة (Google Analytics) لتحسين المنتج.",
    policyLink: "سياسة الخصوصية",
    customize: "التفضيلات",
    necessaryOnly: "الضرورية فقط",
    acceptAll: "قبول الكل",
    settingsTitle: "تفضيلات ملفات تعريف الارتباط",
    necessaryTitle: "ملفات تعريف الارتباط الضرورية",
    necessaryDesc: "مطلوبة لتسجيل الدخول والجلسات والأمان وتفضيل اللغة؛ لا يمكن إيقافها.",
    analyticsTitle: "ملفات تعريف الارتباط التحليلية",
    analyticsDesc: "مشاهدات الصفحات وإحصاءات الاستخدام (Google Analytics / Firebase). لا يتم تحميلها إلا بإذنك؛ يمكنك سحب الإذن في أي وقت.",
    save: "حفظ",
    settingsLink: "تفضيلات ملفات تعريف الارتباط"
  },
  reauth: {
    title: "تأكيد هويتك",
    body: "هذا إجراء حساس، لذا يرجى إدخال كلمة المرور مرة أخرى. يظل التأكيد صالحًا لبضع دقائق.",
    password: "كلمة المرور",
    confirm: "تأكيد",
    wrongPassword: "كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى."
  },
  sessions: {
    countHint: "المستخدمون النشطون خلال آخر 3 دقائق ({{sessions}} جلسة). تُحتسب أجهزة الشخص نفسه مرة واحدة.",
    revoke: "إنهاء",
    confirmRevoke: "إنهاء هذه الجلسة للمستخدم {{user}}؟",
    thisDevice: "هذا الجهاز",
    you: "أنت",
    policyTitle: "سياسة الجلسة",
    idleMinutes: "تسجيل الخروج بعد عدم النشاط (بالدقائق)",
    sessionLimit: "حد المستخدمين المتزامنين",
    rangeError: "أدخل عددًا صحيحًا بين {{min}} و{{max}}.",
    policyHint: "تنطبق على الويب والجوال لجميع مستخدمي شركتك. تُطبَّق المهلة الجديدة فورًا؛ ويُتحقق من حد المستخدمين عند تسجيل الدخول التالي.",
    policyReadOnly: "يحددها مسؤول شركتك.",
    policySaved: "تم حفظ سياسة الجلسة.",
    policyError: "تعذّر حفظ سياسة الجلسة."
  },
  dataTransfer: {
    menu: "استيراد / تصدير",
    exportXlsx: "تنزيل كملف Excel (XLSX)",
    exportCsv: "تنزيل كملف CSV",
    import: "استيراد من ملف…",
    importTitle: "استيراد {{entity}}",
    importHint: "حمّل ملف CSV أو XLSX؛ يجب أن يحتوي الصف الأول على عناوين الأعمدة. حتى {{max}} صف. ستظهر معاينة أولًا ولن يُحفظ شيء دون تأكيد.",
    chooseFile: "اختر ملفًا",
    template: "قالب",
    downloadTemplate: "تنزيل القالب",
    missingColumns: "لم يتم العثور على الأعمدة المطلوبة: {{columns}}",
    tooManyRows: "يحتوي الملف على {{count}} صف؛ يمكن استيراد {{max}} صف كحد أقصى في المرة الواحدة.",
    summary: "{{valid}} صف جاهز، و{{invalid}} صف به أخطاء (سيتم تخطي الصفوف الخاطئة).",
    line: "الصف {{line}}",
    moreErrors: "…و{{count}} صف آخر به أخطاء",
    importCount: "استيراد {{count}} سجل",
    done: "تم إنشاء {{created}} سجل، وفشل {{failed}}.",
    fields: {
      sku: "رمز المخزون",
      name: "الاسم",
      barcode: "الباركود",
      category: "الفئة",
      unit: "الوحدة",
      currentStock: "المخزون الحالي",
      minStockLevel: "الحد الأدنى للمخزون",
      maxStockLevel: "الحد الأقصى للمخزون",
      costPrice: "سعر التكلفة",
      salePrice: "سعر البيع",
      currency: "العملة",
      status: "الحالة",
      description: "الوصف",
      type: "النوع",
      taxId: "الرقم الضريبي",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      address: "العنوان",
      balance: "الرصيد",
      invoiceNo: "رقم الفاتورة",
      vendor: "المورد",
      customer: "العميل",
      issueDate: "تاريخ الإصدار",
      dueDate: "تاريخ الاستحقاق",
      amount: "المبلغ (بدون ضريبة)",
      taxRate: "نسبة الضريبة (%)",
      totalAmount: "الإجمالي",
      date: "التاريخ",
      productName: "اسم المنتج",
      quantity: "الكمية",
      unitCost: "تكلفة الوحدة",
      reason: "السبب",
      lotNumber: "رقم الدفعة",
      peppolId: "معرّف Peppol",
      creditLimit: "حد الائتمان",
      paymentTermDays: "مدة السداد (أيام)",
      taxClass: "الفئة الضريبية",
      barcodes: "أرقام GTIN إضافية",
      hsCode: "رمز HS",
      originCountry: "بلد المنشأ",
      lengthCm: "الطول (سم)",
      widthCm: "العرض (سم)",
      heightCm: "الارتفاع (سم)",
      netWeightKg: "الوزن الصافي (كغ)",
      grossWeightKg: "الوزن الإجمالي (كغ)"
    },
    entities: {
      products: "المنتجات",
      accounts: "الحسابات",
      invoices: "الفواتير",
      stockMovements: "حركات-المخزون"
    },
    rowErrors: {
      required: "{{field}} مطلوب",
      number: "يجب أن يكون {{field}} رقمًا",
      date: "{{field}} ليس تاريخًا صالحًا (DD.MM.YYYY أو YYYY-MM-DD)",
      email: "{{field}} ليس بريدًا إلكترونيًا صالحًا",
      enum: "قيمة {{field}} غير معروفة",
      duplicate: "{{field}} موجود بالفعل",
      party: "يلزم وجود عميل أو مورد",
      positive: "يجب أن يكون {{field}} أكبر من صفر",
      unknownProduct: "لا يوجد منتج بهذا الرمز",
      peppol: "يجب أن يكون {{field}} بصيغة 0088:5790000435951",
      nonNegative: "لا يمكن أن يكون {{field}} سالبًا",
      gtin: "رقم التحقق لـ GTIN في {{field}} غير صحيح",
      hsCode: "يجب أن يتكون {{field}} من 6 إلى 12 رقمًا",
      country: "يجب أن يكون {{field}} رمز ISO من حرفين"
    },
    errors: {
      tooLarge: "يتجاوز الملف حد 5 ميغابايت.",
      unsupported: "يتم دعم ملفات .csv و.xlsx فقط.",
      invalid: "تعذرت قراءة الملف. تحقق من تنسيقه.",
      browser: "لا يستطيع هذا المتصفح قراءة XLSX المضغوط؛ استخدم CSV أو حدّث المتصفح.",
      exportFailed: "فشل التصدير."
    }
  },
  scmUi: {
    openProductBom: "فتح المنتج / قائمة المواد",
    qualityInspections: "فحوصات الجودة",
    packFinishedGoods: "تغليف المنتجات التامة",
    consumeMaterials: "استهلاك المواد",
    postOutput: "ترحيل الناتج",
    lots: "الدفعات",
    serials2: "الأرقام التسلسلية",
    addPallet: "إضافة إلى منصة نقالة",
    ship2: "شحن",
    close: "إغلاق",
    receive: "استلام",
    deactivate: "إلغاء التفعيل",
    confirm: "تأكيد",
    createMo: "إنشاء أمر تصنيع",
    centralReferenceCatalogsSupplyChainDocument: "كتالوجات مرجعية مركزية لعمليات سلسلة التوريد والمستندات.",
    addItem: "إضافة عنصر",
    foundationDirectoryUsersScmPlatformRoles: "الدليل الأساسي للمستخدمين وأدوار سلسلة التوريد / المنصة.",
    packBox: "تعبئة صندوق",
    reverse: "عكس",
    productRequired: "المنتج مطلوب",
    exportOrders: "طلبات التصدير",
    exportOrdersCommercialDocuments: "طلبات التصدير والمستندات التجارية",
    orders: "الطلبات",
    shipments: "الشحنات",
    customs: "الجمارك",
    newExport: "تصدير جديد",
    noExportOrders: "لا توجد طلبات تصدير",
    code: "الرمز",
    customer: "العميل",
    destination: "الوجهة",
    incoterm: "شرط التسليم",
    total: "الإجمالي",
    status: "الحالة",
    open: "فتح",
    exportDocuments: "مستندات التصدير",
    addDoc: "إضافة مستند",
    noDocumentsYet: "لا توجد مستندات بعد",
    type: "النوع",
    no: "الرقم",
    newExportOrder: "طلب تصدير جديد",
    destinationCountry: "بلد الوجهة",
    currency: "العملة",
    forwarder: "وكيل الشحن",
    product: "المنتج",
    select: "اختر…",
    qty: "الكمية",
    unitPrice: "سعر الوحدة",
    hsCode: "رمز النظام المنسق",
    cancel: "إلغاء",
    create: "إنشاء",
    addExportDocument: "إضافة مستند تصدير",
    documentNo: "رقم المستند",
    autoEmpty: "تلقائي إذا كان فارغًا",
    issue: "إصدار",
    invalidTransition: "انتقال غير صالح",
    manufacturingOrderNotFound: "لم يتم العثور على أمر التصنيع",
    execution: "التنفيذ",
    workOrders: "أوامر العمل",
    noWorkOrdersYet: "لا توجد أوامر عمل بعد",
    releaseMoGenerateDefaultSteps: "أطلق أمر التصنيع لإنشاء الخطوات الافتراضية",
    name: "الاسم",
    start: "بدء",
    done: "إنهاء",
    extraStepName: "اسم الخطوة الإضافية",
    add: "إضافة",
    bomConsumption: "قائمة المواد / الاستهلاك",
    noBomLinesAddActiveBom: "لا توجد بنود في قائمة المواد. أضف قائمة مواد نشطة للمنتج أولًا.",
    component: "المكوّن",
    per: "لكل وحدة",
    required: "المطلوب",
    consumed: "المستهلك",
    productionOutput: "ناتج الإنتاج",
    quantity: "الكمية",
    lotBatch: "الدفعة / التشغيلة",
    serialNumbers: "الأرقام التسلسلية",
    commaNewlineSeparated: "افصل بفاصلة أو سطر جديد",
    serials: "الأرقام التسلسلية:",
    internationalShipments: "الشحنات الدولية",
    oceanAirRoadExportMoves: "عمليات التصدير البحرية / الجوية / البرية",
    exportOrders2: "طلبات التصدير",
    containers: "الحاويات",
    newShipment: "شحنة جديدة",
    noShipments: "لا توجد شحنات",
    export: "التصدير",
    route: "المسار",
    mode: "وسيلة النقل",
    container: "الحاوية",
    newInternationalShipment: "شحنة دولية جديدة",
    exportOrder: "طلب التصدير",
    origin: "المنشأ",
    sea: "بحري",
    air: "جوي",
    road: "بري",
    rail: "سكك حديدية",
    attachContainer: "إرفاق حاوية",
    attach: "إرفاق",
    customerProductRequired: "العميل والمنتج مطلوبان",
    confirmOrderFirst: "أكّد الطلب أولًا",
    delivered: "تم التسليم",
    salesOrders: "طلبات المبيعات",
    customers: "العملاء",
    fulfillment: "تنفيذ الطلبات",
    newSo: "طلب مبيعات جديد",
    noSalesOrders: "لا توجد طلبات مبيعات",
    warehouse: "المستودع",
    reserved: "محجوز",
    picked: "تم الانتقاء",
    packed: "تم التغليف",
    price: "السعر",
    newSalesOrder: "طلب مبيعات جديد",
    ship: "الشحن إلى",
    lastMileDelivery: "التوصيل للميل الأخير",
    carrier: "شركة النقل",
    trackingNo: "رقم التتبع",
    confirmDelivery: "تأكيد التسليم",
    titleRequired: "العنوان مطلوب",
    nonConformanceCapa: "عدم المطابقة والإجراءات التصحيحية",
    ncrLifecycleCorrectiveActions: "دورة حياة تقارير عدم المطابقة والإجراءات التصحيحية",
    inspections: "الفحوصات",
    newNcr: "تقرير عدم مطابقة جديد",
    noNonConformances: "لا توجد حالات عدم مطابقة",
    title: "العنوان",
    severity: "درجة الخطورة",
    source: "المصدر",
    correctiveActions: "الإجراءات التصحيحية",
    addCapa: "إضافة إجراء تصحيحي",
    noCapaYet: "لا توجد إجراءات تصحيحية بعد",
    action: "الإجراء",
    owner: "المسؤول",
    description: "الوصف",
    newCorrectiveAction: "إجراء تصحيحي جديد",
    dueDate: "تاريخ الاستحقاق",
    save: "حفظ",
    selectPalletFirst: "اختر منصة نقالة أولًا",
    alreadyPallet: "موجود بالفعل على منصة نقالة",
    packagesPallets: "الطرود والمنصات النقالة",
    boxCartonPackingPalletBuild: "التعبئة في صناديق / كراتين وتجهيز المنصات",
    packages: "الطرود",
    newPackage: "طرد جديد",
    noPackages: "لا توجد طرود",
    pallets: "المنصات النقالة",
    newPallet: "منصة نقالة جديدة",
    noPallets: "لا توجد منصات نقالة",
    pkgs: "الطرود",
    lot: "الدفعة",
    label: "الملصق",
    optionalLabel: "ملصق اختياري",
    warrantyRegistered: "تم تسجيل الضمان",
    claimOpened: "تم فتح المطالبة",
    warrantyExpired: "انتهت صلاحية الضمان",
    serviceOrderCreated: "تم إنشاء أمر الخدمة",
    warranty: "الضمان",
    registrationsClaims: "التسجيلات والمطالبات",
    warranties: "الضمانات",
    service: "الخدمة",
    register: "تسجيل",
    noWarranties: "لا توجد ضمانات",
    ends: "ينتهي",
    claims: "المطالبات",
    newClaim: "مطالبة جديدة",
    noClaims: "لا توجد مطالبات",
    registerWarranty: "تسجيل ضمان",
    serial: "الرقم التسلسلي",
    months: "الأشهر",
    startDate: "تاريخ البدء",
    newWarrantyClaim: "مطالبة ضمان جديدة",
    openClaim: "فتح مطالبة",
    supplierProductRequired: "المورد والمنتج مطلوبان",
    purchaseOrders: "أوامر الشراء",
    poLifecycleStatusHistory: "دورة حياة أمر الشراء مع سجل الحالة",
    newPo: "أمر شراء جديد",
    noPurchaseOrders: "لا توجد أوامر شراء",
    supplier: "المورد",
    details: "التفاصيل",
    newPurchaseOrder: "أمر شراء جديد",
    notes: "ملاحظات",
    nameRequired: "الاسم مطلوب",
    suppliers: "الموردون",
    procurementSupplierMasterData: "البيانات الرئيسية لموردي المشتريات",
    search: "بحث…",
    addSupplier: "إضافة مورد",
    noSuppliers: "لا يوجد موردون",
    addYourFirstSupplier: "أضف أول مورد لك.",
    country: "البلد",
    terms: "الشروط",
    newSupplier: "مورد جديد",
    paymentTerms: "شروط الدفع",
    incoterms: "شروط التسليم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    noData: "لا توجد بيانات",
    count: "العدد",
    scmReports: "تقارير سلسلة التوريد",
    kpisPipelinesRecentAuditActivity: "مؤشرات الأداء وخطوط العمل وآخر نشاط تدقيق",
    refresh: "تحديث",
    salesOrders2: "طلبات المبيعات",
    purchaseOrders2: "أوامر الشراء",
    manufacturing: "التصنيع",
    pendingApprovals: "الموافقات المعلقة",
    returns: "المرتجعات",
    openRmas: "تصاريح الإرجاع المفتوحة",
    lowStockSkus: "أصناف منخفضة المخزون",
    salesPipeline: "مسار المبيعات",
    procurementPipeline: "مسار المشتريات",
    manufacturingPipeline: "مسار التصنيع",
    exportPipeline: "مسار التصدير",
    recentAuditActivity: "آخر نشاط تدقيق",
    noAuditEntries: "لا توجد سجلات تدقيق",
    entity: "الكيان",
    user: "المستخدم",
    generated: "تاريخ الإنشاء",
    selectProduct: "اختر منتجًا",
    invalidStatusTransition: "انتقال حالة غير صالح",
    rfqs: "طلبات عروض الأسعار",
    requestQuotation: "طلب عرض سعر",
    rfqList: "قائمة طلبات عروض الأسعار",
    newRfq: "طلب عرض سعر جديد",
    noRfqs: "لا توجد طلبات عروض أسعار",
    items: "البنود",
    history: "السجل",
    send: "إرسال",
    addQuote: "إضافة عرض سعر",
    createPo: "إنشاء أمر شراء",
    supplierQuotation: "عرض سعر المورد",
    saveQuotation: "حفظ عرض السعر",
    financeIntegration: "التكامل المالي",
    createDraftInvoicesFromSalesPurchase: "إنشاء فواتير مسودة من طلبات المبيعات / الشراء",
    links: "الروابط",
    invoices: "الفواتير",
    noFinanceLinksYet: "لا توجد روابط مالية بعد",
    invoice: "الفاتورة",
    amount: "المبلغ",
    noEligibleSalesOrders: "لا توجد طلبات مبيعات مؤهلة",
    linked: "مرتبط",
    createInvoice: "إنشاء فاتورة",
    noEligiblePurchaseOrders: "لا توجد أوامر شراء مؤهلة",
    nameRequired2: "الاسم مطلوب",
    warehouses: "المستودعات",
    warehouseMasterLocations: "بيانات المستودعات والمواقع",
    addWarehouse: "إضافة مستودع",
    noWarehouses: "لا توجد مستودعات",
    location: "الموقع",
    default: "افتراضي",
    locations: "المواقع",
    newWarehouse: "مستودع جديد",
    finishedGoods: "البضائع التامة الصنع",
    rawMaterial: "المواد الخام",
    overseas3pl: "خارجي / طرف ثالث",
    qualityHold: "حجز الجودة",
    city: "المدينة",
    declarationsDutiesTaxesBrokers: "البيانات والرسوم الجمركية والضرائب والمخلّصون",
    declarations: "البيانات الجمركية",
    newDeclaration: "بيان جديد",
    noCustomsDeclarations: "لا توجد بيانات جمركية",
    declaration: "البيان",
    shipment: "الشحنة",
    duties: "الرسوم الجمركية",
    newCustomsDeclaration: "بيان جمركي جديد",
    declarationNo: "رقم البيان",
    hsCodes: "رموز النظام المنسق",
    commaNewlineDefaultsFromExportLines: "فاصلة أو سطر جديد؛ تؤخذ افتراضيًا من بنود التصدير",
    broker: "المخلّص الجمركي",
    taxes: "الضرائب",
    reservationsPicksPacksDispatchesDeliveries: "الحجوزات والانتقاء والتغليف والإرسال والتسليم",
    reservations: "الحجوزات",
    pickLists: "قوائم الانتقاء",
    packs: "العبوات",
    dispatches: "الإرساليات",
    deliveries: "عمليات التسليم",
    customerMasterSalesOrders: "البيانات الرئيسية للعملاء لطلبات المبيعات",
    priceLists: "قوائم الأسعار",
    noCustomers: "لا يوجد عملاء",
    contact: "جهة الاتصال",
    newCustomer: "عميل جديد",
    billingAddress: "عنوان الفوترة",
    defaultPriceList: "قائمة الأسعار الافتراضية",
    notificationSent: "تم إرسال الإشعار",
    notificationEngine: "محرك الإشعارات",
    myInbox: "صندوق الوارد",
    classicInbox: "صندوق الوارد الكلاسيكي",
    markAllRead: "تعليم الكل كمقروء",
    noNotifications: "لا توجد إشعارات",
    message: "الرسالة",
    unread: "غير مقروء",
    recentEngineEvents: "أحدث أحداث المحرك",
    noEventsLoggedYet: "لا توجد أحداث مسجلة بعد",
    sendNotification: "إرسال إشعار",
    targetUserId: "معرّف المستخدم المستهدف",
    defaultsYou: "الافتراضي: أنت",
    approvalSubmitted: "تم إرسال الطلب للموافقة",
    approvalEngine: "محرك الموافقات",
    workflows: "سير العمل",
    legacyApprovals: "الموافقات القديمة",
    submit: "إرسال",
    noApprovalRequests: "لا توجد طلبات موافقة",
    requester: "مقدّم الطلب",
    approve: "موافقة",
    reject: "رفض",
    submitApproval: "إرسال للموافقة",
    entityType: "نوع الكيان",
    document: "المستند",
    productionPlanning: "تخطيط الإنتاج",
    planFinishedGoodsQuantitiesThenRelease: "خطط كميات المنتجات التامة ثم أطلق أوامر التصنيع",
    plans: "الخطط",
    newPlan: "خطة جديدة",
    noProductionPlans: "لا توجد خطط إنتاج",
    window: "الفترة",
    newProductionPlan: "خطة إنتاج جديدة",
    plannedQuantity: "الكمية المخططة",
    end: "النهاية",
    rmWarehouse: "مستودع المواد الخام",
    fgWarehouse: "مستودع المنتجات التامة",
    customerRequired: "العميل مطلوب",
    serviceOrders: "أوامر الخدمة",
    repairServiceTicketsLinkedRmaWarranty: "تذاكر الإصلاح / الخدمة المرتبطة بتصريح إرجاع أو ضمان",
    newService: "خدمة جديدة",
    noServiceOrders: "لا توجد أوامر خدمة",
    assignee: "المكلَّف",
    newServiceOrder: "أمر خدمة جديد",
    schedule: "الموعد",
    manufacturingOrders: "أوامر التصنيع",
    releaseExecuteConsumeMaterialsPostFinished: "الإطلاق والتنفيذ واستهلاك المواد وترحيل المنتجات التامة",
    newMo: "أمر تصنيع جديد",
    noManufacturingOrders: "لا توجد أوامر تصنيع",
    planned: "المخطط",
    completed: "المكتمل",
    noBom: "لا توجد قائمة مواد",
    newManufacturingOrder: "أمر تصنيع جديد",
    finishedProduct: "المنتج التام",
    activeBomSnapshottedCreate: "تُحفظ نسخة من قائمة المواد النشطة عند الإنشاء",
    plannedQty: "الكمية المخططة",
    inspectionSubmitted: "تم إرسال الفحص",
    approved: "تمت الموافقة",
    ncrCreated: "تم إنشاء تقرير عدم المطابقة",
    recordApproveQualityInspections: "تسجيل فحوصات الجودة والموافقة عليها",
    newInspection: "فحص جديد",
    noInspectionsYet: "لا توجد فحوصات بعد",
    plan: "الخطة",
    result: "النتيجة",
    openNcr: "فتح تقرير عدم مطابقة",
    qualityPlan: "خطة الجودة",
    manufacturingOrder: "أمر التصنيع",
    containerLoadStatusShipmentLink: "حالة تحميل الحاوية وربطها بالشحنة",
    newContainer: "حاوية جديدة",
    noContainers: "لا توجد حاويات",
    containerNo: "رقم الحاوية",
    seal: "الختم",
    sealNo: "رقم الختم",
    overseasWarehouses: "المستودعات الخارجية",
    overseas3plDistributionCenters: "المستودعات الخارجية / مزودو الخدمات اللوجستية / مراكز التوزيع",
    overseas: "خارجي",
    allWarehouses: "جميع المستودعات",
    noOverseasWarehouses: "لا توجد مستودعات خارجية",
    newOverseasWarehouse: "مستودع خارجي جديد",
    selectPoWarehouse: "اختر أمر الشراء والمستودع",
    goodsReceiptPosted: "تم ترحيل استلام البضائع",
    goodsReceipt: "استلام البضائع",
    receiveAgainstPurchaseOrdersIntoWarehouse: "الاستلام إلى المستودع مقابل أوامر الشراء",
    goodsReceipts: "إيصالات الاستلام",
    newReceipt: "استلام جديد",
    noGoodsReceiptsYet: "لا توجد إيصالات استلام بعد",
    lines: "البنود",
    receiveFromPo: "الاستلام من أمر الشراء",
    purchaseOrder: "أمر الشراء",
    ordered: "المطلوب",
    alreadyRecv: "المستلم سابقًا",
    receiveNow: "الاستلام الآن",
    postReceipt: "ترحيل الاستلام",
    qualityPlans: "خطط الجودة",
    inspectionChecklistsPerProduct: "قوائم فحص لكل منتج",
    noQualityPlans: "لا توجد خطط جودة",
    checks: "عمليات الفحص",
    newQualityPlan: "خطة جودة جديدة",
    anyGeneral: "أي / عام",
    checklist: "قائمة الفحص",
    checkDescription: "وصف الفحص",
    returnCreated: "تم إنشاء المرتجع",
    rmaOpened: "تم فتح تصريح الإرجاع",
    customerReturnsInspectRestockRefundScrap: "مرتجعات العملاء: الفحص وإعادة التخزين / الاسترداد / الإتلاف",
    newReturn: "مرتجع جديد",
    noReturns: "لا توجد مرتجعات",
    reason: "السبب",
    openRma: "فتح تصريح إرجاع",
    salesOrder: "طلب المبيعات",
    freightForwarders: "وكلاء الشحن",
    carriersForwardersInternationalMoves: "شركات النقل / وكلاء الشحن للعمليات الدولية",
    forwarders: "وكلاء الشحن",
    noFreightForwarders: "لا يوجد وكلاء شحن",
    newFreightForwarder: "وكيل شحن جديد",
    priceLists2: "قوائم الأسعار",
    customerChannelPricing: "تسعير العملاء / القنوات",
    lists: "القوائم",
    newList: "قائمة جديدة",
    noPriceLists: "لا توجد قوائم أسعار",
    newPriceList: "قائمة أسعار جديدة",
    product2: "المنتج…",
    issueRequired: "وصف المشكلة مطلوب",
    returnMerchandiseAuthorization: "تصريح إرجاع البضائع",
    newRma: "تصريح إرجاع جديد",
    noRmas: "لا توجد تصاريح إرجاع",
    return: "المرتجع",
    createService: "إنشاء خدمة",
    productName: "اسم المنتج",
    itemCreated: "تم إنشاء العنصر.",
    codeAlreadyExistsThisType: "الرمز موجود بالفعل لهذا النوع.",
    masterData: "البيانات الرئيسية",
    referenceTypes: "أنواع المراجع",
    searchCodeName: "ابحث بالرمز أو الاسم…",
    noItems: "لا توجد عناصر",
    seedDefaultsAddNewReferenceItem: "حمّل القيم الافتراضية أو أضف عنصرًا مرجعيًا جديدًا لهذا النوع.",
    active: "نشط",
    inactive: "غير نشط",
    draft: "مسودة",
    obsolete: "متقادم",
    variantName: "اسم المتغير",
    eGSizeLColorBlue: "مثال: المقاس L / اللون أزرق",
    engineeringRev: "المراجعة الهندسية",
    specifications: "المواصفات",
    materialDimensionsStandards: "المادة والأبعاد والمعايير…",
    userManagement: "إدارة المستخدمين",
    adminPanel: "لوحة الإدارة",
    youDoNotHavePermissionManage: "ليس لديك صلاحية إدارة المستخدمين.",
    users: "المستخدمون",
    allRoles: "جميع الأدوار",
    noUsers: "لا يوجد مستخدمون",
    noUsersMatchCurrentFilters: "لا يوجد مستخدمون يطابقون عوامل التصفية الحالية.",
    role: "الدور",
    roleCatalog: "كتالوج الأدوار",
    level: "المستوى",
    signedAs: "تم تسجيل الدخول باسم",
    moOutputReadyPackIntoBoxes: "ناتج التصنيع الجاهز للتعبئة في صناديق / منصات",
    fgFromManufacturing: "المنتجات التامة من التصنيع",
    noFinishedGoodsYet: "لا توجد منتجات تامة بعد",
    completeProductionOutputManufacturingOrderFirst: "أكمل ناتج الإنتاج في أمر تصنيع أولًا",
    warehouseNotFound: "لم يتم العثور على المستودع",
    addLocation: "إضافة موقع",
    aisle: "الممر",
    rack: "الرف",
    bin: "الخانة",
    noLocations: "لا توجد مواقع",
    printLocationLabels: "ملصقات المواقع",
    aisleRackBin: "الممر/الرف/الخانة",
    supplierNotFound: "لم يتم العثور على المورد",
    profile: "الملف التعريفي",
    edit: "تعديل",
    productBothWarehousesAreRequired: "المنتج والمستودعان مطلوبون",
    sourceDestinationMustDiffer: "يجب أن يختلف المصدر عن الوجهة",
    transferPostedNetStockUnchanged: "تم ترحيل التحويل (المخزون الإجمالي دون تغيير)",
    stockTransfer: "تحويل المخزون",
    moveQuantityBetweenWarehousesWithoutChanging: "نقل الكميات بين المستودعات دون تغيير المخزون الإجمالي",
    transfer: "تحويل",
    fromWarehouse: "من المستودع",
    warehouse2: "إلى المستودع",
    min: "الحد الأدنى",
    max: "الحد الأقصى",
    lot2: "الدفعة:",
    reversed: "تم العكس",
    linkedDocuments: "المستندات المرتبطة",
    fileUser: "ملف، مستخدم…"
  }
};

export default ar;
